// Auto-generated from plotter.js — do not edit by hand; run tools/convert_plotter_iife_to_esm.py
var PLOT_DIV_ID = 'plotDiv';
let addMoreFilesBtn, applyCanvasSizeBtn, applyGridFontBtn, applyLabelsBtn, applyRangeBtn, applyTextBtn, axisAlign, axisLabelSize, browseBtn, canvasHeightEl, canvasWidthEl, chartSubtitle, chartTitle, chartTypeSelect, clearAllBtn, clearPlotCanvasBtn, delimiterSelect, dropZone, exportJpeg, exportPdf, exportPng, exportPresetSelect, fileInput, gridX, gridY, leftPanelRoot, leftPanelTxtDat, legendPosition, legendShow, lineWidthScatter, markerBlock, messageEl, panelAssignmentContainer, panelLeft, plotBtn, plotContainer, plotDiv, plotShowLine, plotShowMarkers, previewTable, previewTableContainer, ratioDenominatorSelect, ratioNumeratorSelect, rootTreeContainer, rootTreeFilter, seriesColors, seriesMarkers, startOverBtn, tickSize, toggleRatioBtn, topSection, uploadHint, workspace, workspacePlaceholder, xColumnList, xLabelEl, xLogScale, xMaxEl, xMinEl, xyDisplayBlock, yColumnList, yLabelEl, yLogScale, yMaxEl, yMinEl;
    // ========== CONSTANTS & STATE ==========

    function isLatex(str) {
        if (str == null || typeof str !== 'string') return false;
        var s = str.trim();
        return (/\\[(\[]/.test(s) || /\$[^$]+\$/.test(s) || /\\[a-zA-Z]+\s*\{/.test(s));
    }

    const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1 GB
    const FILE_TYPES = {
        txt: { accept: '.txt,.dat', ext: ['.txt', '.dat'], hint: 'Accepted: .txt, .dat — Max size: 1 GB', parseAsText: true },
        root: { accept: '.root', ext: ['.root'], hint: 'Accepted: .root — TGraph/TH1/TH2/TH3 (with error bars where available). Max size: 1 GB', parseAsText: false },
        numpy: { accept: '.npy', ext: ['.npy'], hint: 'Accepted: .npy (browser support coming soon)', parseAsText: false },
        other: { accept: '*/*', ext: [], hint: 'Any file — parsed as text. Max size: 1 GB', parseAsText: true }
    };
    // ROOT-style default palette (kBlue, kRed, kGreen+1, kMagenta, kOrange)
    const DEFAULT_COLORS = ['#0000ff', '#ff0000', '#008000', '#ff00ff', '#ff7f00'];
    /** Maps UI keys to Plotly line.dash */
    const LINE_STYLE_MAP = {
        solid: 'solid',
        dashed: 'dash',
        dotted: 'dot',
        longdash: 'longdash',
        dashdot: 'dashdot',
        longdashdot: 'longdashdot'
    };
    /** Distinct default symbols when plotting multiple scatter series */
    const DEFAULT_SCATTER_MARKERS = ['circle', 'square', 'diamond', 'cross', 'triangle-up', 'x', 'star', 'hexagon'];

    const MARKER_OPTIONS = [
        { value: 'circle', label: '● Circle' },
        { value: 'square', label: '■ Square' },
        { value: 'diamond', label: '◆ Diamond' },
        { value: 'cross', label: '+ Cross' },
        { value: 'x', label: '× X' },
        { value: 'triangle-up', label: '▲ Triangle' },
        { value: 'triangle-down', label: '▼ Tri down' },
        { value: 'star', label: '★ Star' },
        { value: 'hexagon', label: '⬡ Hex' },
        { value: 'hexagon2', label: '⬢ Hex2' },
        { value: 'pentagon', label: '⬟ Pentagon' },
        { value: 'none', label: 'None' }
    ];
    var ROOT_STYLE = {
        gridColor: '#b0b0b0',
        axisColor: '#000000',
        tickColor: '#000000',
        labelColor: '#000000',
        canvasBg: '#ffffff',
        fontFamily: '"Times New Roman", Times, serif',
        axisFontSize: 14,
        tickFontSize: 12
    };

    const CONFIG_VERSION = 1;
    let rawText = '';
    let parsedData = null;
    let currentChart = null;
    let ratioChart = null;
    var lastPlotState = { traces: [], layout: {}, chartType: null };
    let pendingColumnConfig = null;
    var storedSeriesColors = null;
    /** @type {{ fileName: string, file: object, tree: object[] }[]} */
    var rootSessions = [];
    var rootFileUrl = null;
    var rootKeyNames = [];
    var isRootData = false;
    var lastDataFileName = null;
    var lastDataFileType = null;
    var lastRootTreeForFilter = null;
    /** When true, main chart includes a ratio subplot (numerator/denominator). Toggled via #toggleRatioBtn, not a checkbox. */
    var ratioPanelActive = false;
    /** Guards plotly_afterplot ↔ relayout when syncing minor.dtick */
    var minorDtickSyncInProgress = false;
    /** Skip redundant minor relayouts when signature unchanged */
    var lastMinorDtickSyncSig = '';

    // Export preset widths (px) for manuscript/slide quality
    const EXPORT_PRESETS = {
        screen: null,
        manuscript1: 1000,
        manuscript2: 1800,
        slide: 1500
    };

    // ========== MESSAGES & HELPERS ==========
    function showMessage(text, isError) {
        if (!messageEl) return;
        messageEl.textContent = text;
        messageEl.className = 'message' + (isError ? ' error' : '');
        messageEl.hidden = false;
    }

    function clearMessage() {
        if (messageEl) {
            messageEl.textContent = '';
            messageEl.className = 'message';
            messageEl.hidden = true;
        }
    }

    function isPlotterConfig(obj) {
        return obj && typeof obj === 'object' && (obj.plotterConfig === true || (typeof obj.configVersion === 'number' && obj.configVersion >= 1));
    }

    function getElValue(id) {
        var el = document.getElementById(id);
        if (!el) return undefined;
        if (el.type === 'checkbox') return el.checked;
        return el.value !== undefined ? el.value : undefined;
    }

    // ========== CONFIG ==========
    function getConfig() {
        var xCol = document.querySelector('input[name="xCol"]:checked');
        var yCols = Array.from(document.querySelectorAll('input[name="yCol"]:checked')).map(function (el) { return parseInt(el.value, 10); });
        var seriesColorsArr = [];
        var seriesPointStylesArr = [];
        var seriesLineStylesArr = [];
        var seriesMarkerSizesArr = [];
        var seriesMarkerColorsArr = [];
        if (currentChart && lastPlotState.traces && lastPlotState.traces.length) {
            lastPlotState.traces.forEach(function (t) {
                if (t._seriesRole === 'band') return;
                if (t.yaxis === 'y2') return;
                var c = (t.line && t.line.color) || (t.marker && t.marker.color) || '';
                seriesColorsArr.push(typeof c === 'string' ? c : '#06328a');
                var pt = (t.marker && t.marker.size === 0) ? 'none' : (t.marker && t.marker.symbol) || 'circle';
                seriesPointStylesArr.push(pt);
                seriesLineStylesArr.push(traceToLineStyleKey(t));
                if (t.marker) {
                    seriesMarkerSizesArr.push(typeof t.marker.size === 'number' ? t.marker.size : 8);
                    var mc = t.marker.color || (t.line && t.line.color) || '';
                    seriesMarkerColorsArr.push(typeof mc === 'string' && mc.startsWith('#') ? mc : '#06328a');
                }
            });
        }
        var ct = lastPlotState.chartType || null;
        var t0 = null;
        if (lastPlotState.traces && lastPlotState.traces.length) {
            for (var ti = 0; ti < lastPlotState.traces.length; ti++) {
                if (lastPlotState.traces[ti]._seriesRole !== 'band' && lastPlotState.traces[ti].yaxis !== 'y2') {
                    t0 = lastPlotState.traces[ti];
                    break;
                }
            }
        }
        var scatterShowLine = plotShowLine ? plotShowLine.checked : ((ct === 'scatter' && t0 && t0.mode && t0.mode.indexOf('lines') >= 0) || undefined);
        var scatterLineWidth = (t0 && t0.line && typeof t0.line.width === 'number') ? t0.line.width : undefined;
        var lineShowMarker = plotShowMarkers ? plotShowMarkers.checked : ((ct === 'line' && t0 && t0.marker && t0.marker.size > 0) || undefined);
        return {
            plotterConfig: true,
            configVersion: CONFIG_VERSION,
            delimiter: delimiterSelect ? delimiterSelect.value : 'auto',
            chartType: chartTypeSelect ? chartTypeSelect.value : 'scatter',
            xColumn: xCol != null ? parseInt(xCol.value, 10) : 0,
            yColumns: yCols.length ? yCols : [1],
            xMin: getElValue('xMin'),
            xMax: getElValue('xMax'),
            yMin: getElValue('yMin'),
            yMax: getElValue('yMax'),
            xLabel: getElValue('xLabel'),
            yLabel: getElValue('yLabel'),
            tickDivisions: getElValue('tickDivisions'),
            subTicks: getElValue('subTicks'),
            gridX: gridX ? gridX.checked : false,
            gridY: gridY ? gridY.checked : false,
            axisLabelSize: getElValue('axisLabelSize'),
            tickSize: getElValue('tickSize'),
            axisAlign: getElValue('axisAlign'),
            xLogScale: xLogScale ? xLogScale.checked : false,
            yLogScale: yLogScale ? yLogScale.checked : false,
            seriesColors: seriesColorsArr.length ? seriesColorsArr : undefined,
            seriesPointStyles: seriesPointStylesArr.length ? seriesPointStylesArr : undefined,
            seriesLineStyles: seriesLineStylesArr.length ? seriesLineStylesArr : undefined,
            seriesMarkerSizes: seriesMarkerSizesArr.length ? seriesMarkerSizesArr : undefined,
            seriesMarkerColors: seriesMarkerColorsArr.length ? seriesMarkerColorsArr : undefined,
            plotShowLine: plotShowLine ? plotShowLine.checked : undefined,
            plotShowMarkers: plotShowMarkers ? plotShowMarkers.checked : undefined,
            scatterShowLine: scatterShowLine,
            scatterLineWidth: scatterLineWidth,
            lineShowMarker: lineShowMarker,
            legendShow: legendShow ? legendShow.checked : true,
            legendPosition: legendPosition ? legendPosition.value : 'top',
            chartTitle: getElValue('chartTitle'),
            chartSubtitle: getElValue('chartSubtitle'),
            exportPreset: getElValue('exportPreset'),
            rootNormalize: (document.getElementById('rootNormalize') || {}).checked || false,
            rootStack: (document.getElementById('rootStack') || {}).checked || false,
            showRatioPanel: ratioPanelActive,
            enableRatio: ratioPanelActive,
            ratioNumerator: ratioNumeratorSelect ? ratioNumeratorSelect.value : undefined,
            ratioDenominator: ratioDenominatorSelect ? ratioDenominatorSelect.value : undefined,
            ratioAxisTitle: getElValue('ratioAxisTitle'),
            ratioAxisYMin: getElValue('ratioAxisYMin'),
            ratioAxisYMax: getElValue('ratioAxisYMax')
        };
    }

    function setElValue(id, value) {
        var el = document.getElementById(id);
        if (!el) return;
        if (el.type === 'checkbox') el.checked = !!value;
        else el.value = value === undefined || value === null ? '' : String(value);
    }
    function setElChecked(id, checked) {
        var el = document.getElementById(id);
        if (el && el.type === 'checkbox') el.checked = !!checked;
    }

    function getNumEl(id, defaultVal) {
        var el = document.getElementById(id);
        if (!el || el.value === '') return defaultVal;
        var n = parseInt(el.value, 10);
        return isNaN(n) ? defaultVal : n;
    }

    function plotlyDashToLineStyleKey(dash) {
        if (!dash || dash === 'solid') return 'solid';
        if (dash === 'dash') return 'dashed';
        if (dash === 'dot') return 'dotted';
        if (dash === 'longdash') return 'longdash';
        if (dash === 'dashdot') return 'dashdot';
        if (dash === 'longdashdot') return 'longdashdot';
        return 'solid';
    }

    function applyConfig(cfg) {
        if (!cfg || !isPlotterConfig(cfg)) return false;
        if (cfg.delimiter != null) { var d = document.getElementById('delimiter'); if (d) d.value = cfg.delimiter; }
        if (cfg.chartType != null) { var ct = document.getElementById('chartType'); if (ct) ct.value = cfg.chartType; }
        if (cfg.xMin !== undefined) setElValue('xMin', cfg.xMin);
        if (cfg.xMax !== undefined) setElValue('xMax', cfg.xMax);
        if (cfg.yMin !== undefined) setElValue('yMin', cfg.yMin);
        if (cfg.yMax !== undefined) setElValue('yMax', cfg.yMax);
        if (cfg.xLabel !== undefined) setElValue('xLabel', cfg.xLabel);
        if (cfg.yLabel !== undefined) setElValue('yLabel', cfg.yLabel);
        if (cfg.tickDivisions !== undefined) setElValue('tickDivisions', cfg.tickDivisions);
        if (cfg.subTicks !== undefined) setElValue('subTicks', String(cfg.subTicks));
        if (cfg.gridX !== undefined) setElChecked('gridX', cfg.gridX);
        if (cfg.gridY !== undefined) setElChecked('gridY', cfg.gridY);
        if (cfg.axisLabelSize !== undefined) setElValue('axisLabelSize', String(cfg.axisLabelSize));
        if (cfg.tickSize !== undefined) setElValue('tickSize', String(cfg.tickSize));
        if (cfg.axisAlign !== undefined) setElValue('axisAlign', cfg.axisAlign);
        if (cfg.xLogScale !== undefined) setElChecked('xLogScale', cfg.xLogScale);
        if (cfg.yLogScale !== undefined) setElChecked('yLogScale', cfg.yLogScale);
        if (cfg.legendShow !== undefined) setElChecked('legendShow', cfg.legendShow);
        if (cfg.legendPosition !== undefined) setElValue('legendPosition', cfg.legendPosition);
        if (cfg.chartTitle !== undefined) setElValue('chartTitle', cfg.chartTitle);
        if (cfg.chartSubtitle !== undefined) setElValue('chartSubtitle', cfg.chartSubtitle);
        if (cfg.exportPreset !== undefined) setElValue('exportPreset', cfg.exportPreset);
        if (cfg.rootNormalize !== undefined) setElChecked('rootNormalize', cfg.rootNormalize);
        if (cfg.rootStack !== undefined) setElChecked('rootStack', cfg.rootStack);
        if (cfg.showRatioPanel !== undefined) ratioPanelActive = !!cfg.showRatioPanel;
        else if (cfg.enableRatio !== undefined) ratioPanelActive = !!cfg.enableRatio;
        if (cfg.ratioAxisTitle !== undefined) setElValue('ratioAxisTitle', cfg.ratioAxisTitle);
        if (cfg.ratioAxisYMin !== undefined) setElValue('ratioAxisYMin', cfg.ratioAxisYMin);
        if (cfg.ratioAxisYMax !== undefined) setElValue('ratioAxisYMax', cfg.ratioAxisYMax);
        if (cfg.plotShowLine !== undefined) setElChecked('plotShowLine', cfg.plotShowLine);
        if (cfg.plotShowMarkers !== undefined) setElChecked('plotShowMarkers', cfg.plotShowMarkers);
        function applyCfgToTraces() {
            if (!lastPlotState.traces) return;
            if (cfg.seriesColors && Array.isArray(cfg.seriesColors)) {
                cfg.seriesColors.forEach(function (hex, i) {
                    if (hex) applySeriesColor(i, hex);
                });
            }
            if (cfg.seriesPointStyles && Array.isArray(cfg.seriesPointStyles)) {
                cfg.seriesPointStyles.forEach(function (pt, i) {
                    var t = nthMainTrace(i);
                    if (!t) return;
                    if (!t.marker) t.marker = {};
                    if (pt === 'none') { t.marker.size = 0; t.mode = (t.mode && t.mode.indexOf('lines') >= 0) ? 'lines' : 'markers'; }
                    else { t.marker.symbol = pt; t.marker.size = 8; t.mode = (t.mode && t.mode.indexOf('lines') >= 0) ? 'lines+markers' : 'markers'; }
                });
            }
            if (cfg.seriesLineStyles && Array.isArray(cfg.seriesLineStyles)) {
                cfg.seriesLineStyles.forEach(function (key, i) {
                    var t = nthMainTrace(i);
                    if (t && t.line) t.line.dash = LINE_STYLE_MAP[key] || 'solid';
                });
            }
            if (cfg.seriesMarkerSizes && Array.isArray(cfg.seriesMarkerSizes)) {
                cfg.seriesMarkerSizes.forEach(function (sz, i) {
                    var t = nthMainTrace(i);
                    if (t && t.marker) t.marker.size = sz;
                });
            }
            if (cfg.seriesMarkerColors && Array.isArray(cfg.seriesMarkerColors)) {
                cfg.seriesMarkerColors.forEach(function (hex, i) {
                    var t = nthMainTrace(i);
                    if (t && hex) syncMarkerAndErrorColor(t, hex);
                });
            }
            if (cfg.plotShowLine !== undefined || cfg.plotShowMarkers !== undefined || cfg.scatterShowLine !== undefined || cfg.lineShowMarker !== undefined || (cfg.scatterLineWidth !== undefined && cfg.scatterLineWidth >= 1)) {
                applyLineMarkerOptsFromConfig(cfg);
            }
            updatePlotlyChart();
        }
        if (cfg.seriesColors && Array.isArray(cfg.seriesColors) && currentChart && lastPlotState.traces) applyCfgToTraces();
        else if (cfg.seriesPointStyles && Array.isArray(cfg.seriesPointStyles) && currentChart && lastPlotState.traces) applyCfgToTraces();
        else if (cfg.seriesLineStyles && Array.isArray(cfg.seriesLineStyles) && currentChart && lastPlotState.traces) applyCfgToTraces();
        else if (cfg.seriesMarkerSizes && Array.isArray(cfg.seriesMarkerSizes) && currentChart && lastPlotState.traces) applyCfgToTraces();
        else if (cfg.seriesMarkerColors && Array.isArray(cfg.seriesMarkerColors) && currentChart && lastPlotState.traces) applyCfgToTraces();
        if (currentChart && seriesColors) {
            fillSeriesColors();
            updateChartTypeBlocks();
        }
        if (currentChart && lastPlotState.traces && lastPlotState.traces.length) {
            var ct = getChartType();
            if ((ct === 'scatter' || ct === 'line') && (cfg.plotShowLine !== undefined || cfg.plotShowMarkers !== undefined || cfg.scatterShowLine !== undefined || cfg.lineShowMarker !== undefined || (cfg.scatterLineWidth !== undefined && cfg.scatterLineWidth >= 1))) applyCfgToTraces();
            updateChartTypeBlocks();
        }
        if (parsedData && cfg.xColumn != null) {
            var xRadio = document.querySelector('input[name="xCol"][value="' + cfg.xColumn + '"]');
            if (xRadio) xRadio.checked = true;
        }
        if (parsedData && cfg.yColumns && Array.isArray(cfg.yColumns)) {
            document.querySelectorAll('input[name="yCol"]').forEach(function (el) {
                el.checked = cfg.yColumns.indexOf(parseInt(el.value, 10)) !== -1;
            });
        }
        if (!parsedData && (cfg.xColumn != null || (cfg.yColumns && cfg.yColumns.length))) {
            pendingColumnConfig = { xColumn: cfg.xColumn != null ? cfg.xColumn : 0, yColumns: cfg.yColumns && cfg.yColumns.length ? cfg.yColumns : [1] };
        }
        if (parsedData && (cfg.xColumn != null || (cfg.yColumns && cfg.yColumns.length))) {
            if (cfg.ratioNumerator != null && ratioNumeratorSelect) ratioNumeratorSelect.value = String(cfg.ratioNumerator);
            if (cfg.ratioDenominator != null && ratioDenominatorSelect) ratioDenominatorSelect.value = String(cfg.ratioDenominator);
            buildChart();
            if (currentChart && lastPlotState.traces && lastPlotState.traces.length) {
                if (cfg.seriesColors && Array.isArray(cfg.seriesColors)) {
                    cfg.seriesColors.forEach(function (hex, i) {
                        if (hex) applySeriesColor(i, hex);
                    });
                }
                if (cfg.seriesPointStyles && Array.isArray(cfg.seriesPointStyles)) {
                    cfg.seriesPointStyles.forEach(function (pt, i) {
                        var t = nthMainTrace(i);
                        if (!t) return;
                        if (!t.marker) t.marker = {};
                        if (pt === 'none') { t.marker.size = 0; t.mode = (t.mode && t.mode.indexOf('lines') >= 0) ? 'lines' : 'markers'; }
                        else { t.marker.symbol = pt; t.marker.size = 8; t.mode = (t.mode && t.mode.indexOf('lines') >= 0) ? 'lines+markers' : 'markers'; }
                    });
                }
                if (cfg.seriesLineStyles && Array.isArray(cfg.seriesLineStyles)) {
                    cfg.seriesLineStyles.forEach(function (key, i) {
                        var t = nthMainTrace(i);
                        if (t && t.line) t.line.dash = LINE_STYLE_MAP[key] || 'solid';
                    });
                }
                if (cfg.seriesMarkerSizes && Array.isArray(cfg.seriesMarkerSizes)) {
                    cfg.seriesMarkerSizes.forEach(function (sz, i) {
                        var t = nthMainTrace(i);
                        if (t && t.marker) t.marker.size = sz;
                    });
                }
                if (cfg.seriesMarkerColors && Array.isArray(cfg.seriesMarkerColors)) {
                    cfg.seriesMarkerColors.forEach(function (hex, i) {
                        var t = nthMainTrace(i);
                        if (t && hex) syncMarkerAndErrorColor(t, hex);
                    });
                }
                if (cfg.plotShowLine !== undefined || cfg.plotShowMarkers !== undefined || cfg.scatterShowLine !== undefined || cfg.lineShowMarker !== undefined || (cfg.scatterLineWidth !== undefined && cfg.scatterLineWidth >= 1)) {
                    applyLineMarkerOptsFromConfig(cfg);
                }
                updatePlotlyChart();
                fillSeriesColors();
                updateChartTypeBlocks();
            }
        } else if (cfg.seriesColors && Array.isArray(cfg.seriesColors) && !currentChart) {
            storedSeriesColors = cfg.seriesColors;
        }
        syncRatioToggleButton();
        return true;
    }

    // ========== FILE & PARSING ==========
    function detectFileType(file) {
        if (!file || !file.name) return 'other';
        var name = (file.name || '').toLowerCase();
        if (name.endsWith('.json')) return 'json';
        if (name.endsWith('.root')) return 'root';
        if (name.endsWith('.txt') || name.endsWith('.dat')) return 'txt';
        if (name.endsWith('.npy')) return 'numpy';
        return 'other';
    }

    function isValidFile(file) {
        if (!file) return false;
        var type = detectFileType(file);
        if (type === 'json') return true;
        var config = FILE_TYPES[type] || FILE_TYPES.other;
        var name = (file.name || '').toLowerCase();
        if (config.ext.length > 0 && !config.ext.some(function (ext) { return name.endsWith(ext); })) {
            if (type === 'other') { /* any file allowed as text */ } else {
                showMessage('Unsupported file extension. Use .txt, .dat, .root, or .json.', true);
                return false;
            }
        }
        if (file.size > MAX_FILE_SIZE) {
            showMessage('File is too large. Maximum size is 1 GB.', true);
            return false;
        }
        if (type === 'numpy') {
            showMessage('NumPy (.npy) is not yet supported. Use .txt, .dat, or .root.', true);
            return false;
        }
        return true;
    }

    function detectDelimiter(text) {
        const firstLine = text.split('\n')[0] || '';
        if (firstLine.includes('\t')) return '\t';
        if (firstLine.includes(',')) return ',';
        return /\s+/;
    }

    function parseText(text, delimiter) {
        const sep = delimiter === 'auto' ? detectDelimiter(text) :
            delimiter === 'tab' ? '\t' : delimiter === 'comma' ? ',' : /\s+/;
        const lines = text.split(/\r?\n/).filter(line => line.trim());
        if (lines.length === 0) return null;
        const rows = lines.map(line => {
            const parts = typeof sep === 'string' ? line.split(sep) : line.split(sep).filter(Boolean);
            return parts.map(p => p.trim());
        });
        const numCols = Math.max(...rows.map(r => r.length));
        const headers = [];
        let dataStart = 0;
        const firstRow = rows[0];
        const firstRowNumeric = firstRow.every(cell => !isNaN(parseFloat(cell)) && cell.trim() !== '');
        if (!firstRowNumeric && firstRow.length >= 1) {
            headers.push(...firstRow);
            while (headers.length < numCols) headers.push('Col ' + headers.length);
            dataStart = 1;
        } else {
            for (let i = 0; i < numCols; i++) headers.push('Col ' + (i + 1));
        }
        const numRows = rows.slice(dataStart).map(row => {
            const out = [];
            for (let i = 0; i < numCols; i++) {
                const val = row[i] !== undefined && row[i] !== '' ? parseFloat(row[i]) : NaN;
                out.push(isNaN(val) ? null : val);
            }
            return out;
        });
        return { headers, rows: numRows };
    }

    function escapeHtml(s) {
        const div = document.createElement('div');
        div.textContent = s;
        return div.innerHTML;
    }

    /** Plotly renders LaTeX in axis titles when wrapped in $...$ (not raw $$). */
    function hexToRgba(hex, alpha) {
        if (typeof hex !== 'string' || !hex.startsWith('#')) return 'rgba(6,50,138,' + alpha + ')';
        var h = hex.slice(1);
        if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
        if (h.length < 6) return 'rgba(6,50,138,' + alpha + ')';
        var r = parseInt(h.slice(0, 2), 16);
        var g = parseInt(h.slice(2, 4), 16);
        var b = parseInt(h.slice(4, 6), 16);
        if (isNaN(r) || isNaN(g) || isNaN(b)) return 'rgba(6,50,138,' + alpha + ')';
        return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
    }

    function formatPlotlyLatex(text) {
        if (text == null) return '';
        var t = String(text).trim();
        if (!t) return '';
        if (/^\$\$[\s\S]*\$\$$/m.test(t)) {
            t = '$' + t.replace(/^\$\$\s*/, '').replace(/\s*\$\$$/, '') + '$';
        }
        if (!/^\$[\s\S]*\$$/.test(t)) {
            if (/\\[a-zA-Z]+|[\^_]|\\frac|\\sqrt|\\sum|\\int|\\partial|\\cdot|\\times|\\pm/.test(t)) {
                t = '$' + t + '$';
            }
        }
        return t;
    }

    function syncTraceColors(t, color) {
        if (!t || typeof color !== 'string') return;
        if (t.line) t.line.color = color;
        if (t.marker) t.marker.color = color;
        if (t.error_y) t.error_y.color = color;
    }

    function syncMarkerAndErrorColor(t, color) {
        if (!t || typeof color !== 'string') return;
        if (t.marker) t.marker.color = color;
        if (t.error_y) t.error_y.color = color;
    }

    /** Update line/marker/error or error-band fill for all Plotly traces belonging to logical series `sid`. */
    function applySeriesColor(sid, hex) {
        if (!lastPlotState.traces) return;
        lastPlotState.traces.forEach(function (t, ti) {
            var match = (t._seriesIndex != null) ? (t._seriesIndex === sid) : (ti === sid);
            if (!match) return;
            if (t._seriesRole === 'band') {
                t.fillcolor = hexToRgba(hex, 0.22);
            } else {
                syncTraceColors(t, hex);
            }
        });
    }

    /** n-th logical series trace (skips error-band polygons). */
    function nthMainTrace(n) {
        if (!lastPlotState.traces) return null;
        var seen = 0;
        for (var j = 0; j < lastPlotState.traces.length; j++) {
            var t = lastPlotState.traces[j];
            if (t._seriesRole === 'band') continue;
            if (t.yaxis === 'y2') continue;
            if (seen === n) return t;
            seen++;
        }
        return null;
    }

    function applyLineMarkerOptsFromConfig(cfg) {
        if (!cfg || !lastPlotState.traces || !lastPlotState.traces.length) return;
        var ct = lastPlotState.chartType;
        if (ct !== 'scatter' && ct !== 'line') return;
        var showL = cfg.plotShowLine;
        var showM = cfg.plotShowMarkers;
        if (showL === undefined && cfg.scatterShowLine !== undefined) showL = cfg.scatterShowLine;
        if (showL === undefined) showL = (ct === 'line');
        if (showM === undefined && cfg.lineShowMarker !== undefined) showM = cfg.lineShowMarker;
        if (showM === undefined) showM = (ct === 'scatter');
        var w = (cfg.scatterLineWidth !== undefined && cfg.scatterLineWidth >= 1 && cfg.scatterLineWidth <= 8) ? cfg.scatterLineWidth : 2;
        if (plotShowLine) plotShowLine.checked = !!showL;
        if (plotShowMarkers) plotShowMarkers.checked = !!showM;
        if (lineWidthScatter) lineWidthScatter.value = String(w);
        var lwr = document.getElementById('lineWidthScatterRange');
        if (lwr) lwr.value = String(w);
        lastPlotState.traces.forEach(function (t) {
            if (t._seriesRole === 'band' || t.type !== 'scatter') return;
            t.mode = showL && showM ? 'lines+markers' : (showL ? 'lines' : 'markers');
            if (t.line) t.line.width = showL ? w : 2;
            if (t.marker) {
                if (!showM) t.marker.size = 0;
                else if (!t.marker.size) t.marker.size = 8;
                if (showM && !t.marker.symbol) t.marker.symbol = 'circle';
            }
        });
    }

    function handleFile(file) {
        if (!file) return;
        clearMessage();
        var name = (file.name || '').toLowerCase();
        if (name.endsWith('.json')) {
            if (file.size > MAX_FILE_SIZE) { showMessage('File is too large. Maximum size is 1 GB.', true); return; }
            var reader = new FileReader();
            reader.onload = function (e) {
                try {
                    var parsed = JSON.parse(e.target.result);
                    if (applyConfig(parsed)) {
                        showMessage('Configuration loaded.' + (parsedData ? ' Chart updated.' : ' Load a data file and click Plot to apply.'));
                    } else {
                        showMessage('Not a valid plotter configuration file.', true);
                    }
                } catch (err) {
                    showMessage('Invalid JSON: ' + err.message, true);
                }
            };
            reader.onerror = function () { showMessage('Failed to read file.', true); };
            reader.readAsText(file, 'UTF-8');
            return;
        }
        if (!isValidFile(file)) return;
        var type = detectFileType(file);
        lastDataFileName = file.name || null;
        lastDataFileType = type;
        if (type === 'root') {
            handleRootFile(file);
            return;
        }
        var config = FILE_TYPES[type] || FILE_TYPES.other;
        if (!config.parseAsText) return;
        var reader = new FileReader();
        reader.onload = function (e) {
            rawText = e.target.result;
            applyDelimiterAndRefresh();
        };
        reader.onerror = function () { showMessage('Failed to read file.', true); };
        reader.readAsText(file, 'UTF-8');
    }

    function getKeysFromDir(dir) {
        if (!dir) return [];
        var keys = dir.fKeys || dir._keys || dir.keys;
        if (typeof dir.getKeys === 'function') {
            try {
                var fromMethod = dir.getKeys();
                if (Array.isArray(fromMethod)) return fromMethod;
                if (fromMethod && typeof fromMethod.length === 'number') return Array.prototype.slice.call(fromMethod);
            } catch (e) { /* ignore */ }
        }
        if (Array.isArray(keys)) return keys;
        if (keys && typeof keys.length === 'number' && keys.length >= 0)
            return Array.prototype.slice.call(keys);
        return [];
    }

    function isDirectoryKey(key) {
        var cn = (key.fClassName || key.className || '').toString();
        return cn.indexOf('TDirectory') === 0;
    }

    function skipKey(key) {
        var cn = (key.fClassName || key.className || '').toString();
        return cn.indexOf('TStreamer') === 0 || cn === 'TList' && (key.fName || '').indexOf('Streamer') !== -1;
    }

    function collectAllKeyPathsRecursive(file, dir, prefix) {
        var keys = getKeysFromDir(dir);
        var result = [];
        var dirPromises = [];
        var i, k, name, cycle, path, pathCycle;
        for (i = 0; i < keys.length; i++) {
            k = keys[i];
            if (!k || skipKey(k)) continue;
            name = k.fName || k.name || '';
            cycle = k.fCycle != null ? k.fCycle : (k.cycle != null ? k.cycle : 1);
            path = prefix ? prefix + '/' + name : name;
            pathCycle = path + ';' + cycle;
            result.push(pathCycle);
            if (isDirectoryKey(k)) {
                dirPromises.push(
                    file.readObject(path, cycle).then((function (p) {
                        return function (subdir) { return collectAllKeyPathsRecursive(file, subdir, p); };
                    })(path))
                );
            }
        }
        if (dirPromises.length === 0) return Promise.resolve(result);
        return Promise.all(dirPromises).then(function (arrays) {
            var j, a;
            for (j = 0; j < arrays.length; j++) {
                for (a = 0; a < arrays[j].length; a++) result.push(arrays[j][a]);
            }
            return result;
        });
    }

    function collectAllKeysFlat(file) {
        var keys = getKeysFromDir(file);
        var result = [];
        var i, k, name, cycle, path, pathCycle;
        for (i = 0; i < keys.length; i++) {
            k = keys[i];
            if (!k || skipKey(k)) continue;
            name = k.fName || k.name || '';
            cycle = k.fCycle != null ? k.fCycle : (k.cycle != null ? k.cycle : 1);
            path = name;
            pathCycle = path + ';' + cycle;
            result.push(pathCycle);
        }
        return result;
    }

    function isPlottableKey(key) {
        var cn = (key.fClassName || key.className || '').toString();
        return cn.indexOf('TGraph') !== -1 || cn.indexOf('TH1') !== -1 || cn.indexOf('TH2') !== -1 || cn.indexOf('TH3') !== -1 || cn.indexOf('TProfile') !== -1 || cn.indexOf('TF1') !== -1;
    }

    function buildRootTree(file, dir, prefix, sessionIndex) {
        var sess = (sessionIndex !== undefined && sessionIndex !== null) ? sessionIndex : 0;
        var keys = getKeysFromDir(dir);
        var nodes = [];
        var dirPromises = [];
        var i, k, name, cycle, path, pathCycle, node;
        for (i = 0; i < keys.length; i++) {
            k = keys[i];
            if (!k || skipKey(k)) continue;
            name = k.fName || k.name || '';
            cycle = k.fCycle != null ? k.fCycle : (k.cycle != null ? k.cycle : 1);
            path = prefix ? prefix + '/' + name : name;
            pathCycle = sess + '::' + path + ';' + cycle;
            if (isDirectoryKey(k)) {
                node = { name: name, pathCycle: pathCycle, isDir: true, children: [], expanded: false };
                nodes.push(node);
                dirPromises.push(
                    file.readObject(path, cycle).then((function (p, n, si) {
                        return function (subdir) { return buildRootTree(file, subdir, p, si).then(function (kids) { n.children = kids; return n; }); };
                    })(path, node, sess))
                );
            } else if (isPlottableKey(k)) {
                nodes.push({ name: name, pathCycle: pathCycle, isDir: false, className: (k.fClassName || k.className || '') });
            }
        }
        if (dirPromises.length === 0) return Promise.resolve(nodes);
        return Promise.all(dirPromises).then(function () { return nodes; });
    }

    /** Convert ROOT axis/label macros to LaTeX for axis titles (e.g. #varphi -> $\\varphi$) */
    function rootToLatex(str) {
        if (str == null || typeof str !== 'string') return '';
        var s = str.trim();
        var map = {
            '#Delta': '\\Delta', '#Gamma': '\\Gamma', '#Lambda': '\\Lambda',
            '#varphi': '\\varphi', '#phi': '\\phi', '#theta': '\\theta', '#sigma': '\\sigma',
            '#alpha': '\\alpha', '#beta': '\\beta', '#gamma': '\\gamma', '#delta': '\\delta',
            '#epsilon': '\\epsilon', '#mu': '\\mu', '#pi': '\\pi', '#rho': '\\rho',
            '#tau': '\\tau', '#omega': '\\omega', '#Omega': '\\Omega', '#infty': '\\infty'
        };
        Object.keys(map).forEach(function (k) {
            s = s.split(k).join('$' + map[k] + '$');
        });
        return s;
    }

    /** Convert ROOT macros to Unicode for plain-text legend (e.g. #varphi -> φ) */
    function rootToUnicode(str) {
        if (str == null || typeof str !== 'string') return '';
        var s = str.trim();
        var map = {
            '#varphi': '\u03D5', '#phi': '\u03C6', '#theta': '\u03B8', '#sigma': '\u03C3',
            '#alpha': '\u03B1', '#beta': '\u03B2', '#gamma': '\u03B3', '#delta': '\u03B4',
            '#epsilon': '\u03B5', '#mu': '\u03BC', '#pi': '\u03C0', '#rho': '\u03C1',
            '#tau': '\u03C4', '#omega': '\u03C9', '#Omega': '\u03A9', '#infty': '\u221E'
        };
        Object.keys(map).forEach(function (k) {
            s = s.split(k).join(map[k]);
        });
        return s;
    }

    function getAxisLabel(axis) {
        if (!axis) return '';
        var t = axis.fTitle || axis._title || axis.title;
        var raw = (t != null && typeof t === 'string') ? t.trim() : '';
        return rootToLatex(raw) || raw;
    }

    /** Treat typed arrays and array-likes as arrays (JSROOT often returns Float32Array for TGraph). */
    function asArray(arr) {
        if (!arr || typeof arr.length !== 'number') return null;
        if (Array.isArray(arr)) return arr;
        var out = [];
        for (var i = 0; i < arr.length; i++) out.push(arr[i]);
        return out;
    }

    function rootObjectToParsedData(obj) {
        if (!obj) return null;
        var tn = (obj._typename || obj.fClassName || obj.className || '').toLowerCase();
        var headers, rows;
        var axisLabels = { x: getAxisLabel(obj.fXaxis || obj.xaxis), y: getAxisLabel(obj.fYaxis || obj.yaxis) };
        if (!axisLabels.x && !axisLabels.y) axisLabels = undefined;

        if (tn.indexOf('tgraph') !== -1) {
            var xarr = asArray(obj.fX || obj._x || obj.arr_x || obj.x);
            var yarr = asArray(obj.fY || obj._y || obj.arr_y || obj.y);
            if (!xarr || !yarr || xarr.length === 0 || yarr.length === 0) return null;
            var n = Math.min(xarr.length, yarr.length);
            var exarr = asArray(obj.fEX || obj._ex || obj.arr_ex) || [];
            var eyarr = asArray(obj.fEY || obj._ey || obj.arr_ey) || [];
            var hasYErr = eyarr.length >= n;
            rows = [];
            var yErrors;
            if (hasYErr) yErrors = [];
            for (var i = 0; i < n; i++) {
                rows.push([xarr[i], yarr[i]]);
                if (hasYErr) yErrors.push(eyarr[i] != null && !isNaN(eyarr[i]) ? Math.abs(Number(eyarr[i])) : 0);
            }
            var out = { headers: ['x', 'y'], rows: rows };
            if (axisLabels) out.axisLabels = axisLabels;
            if (yErrors) out.yErrors = yErrors;
            return out;
        }

        if (tn.indexOf('tprofile') !== -1) {
            var arr = obj.fArray || obj._data || obj.array || [];
            var nbins = obj.fNbinsX || obj.fNcells || (arr && arr.length) || 0;
            var xmin = (obj.fXaxis && (obj.fXaxis.fXmin != null ? obj.fXaxis.fXmin : obj.fXaxis._xmin)) != null ? (obj.fXaxis.fXmin != null ? obj.fXaxis.fXmin : obj.fXaxis._xmin) : 0;
            var xmax = (obj.fXaxis && (obj.fXaxis.fXmax != null ? obj.fXaxis.fXmax : obj.fXaxis._xmax)) != null ? (obj.fXaxis.fXmax != null ? obj.fXaxis.fXmax : obj.fXaxis._xmax) : 1;
            if (nbins <= 0 && arr.length) nbins = arr.length;
            rows = [];
            var sumw2 = obj.fSumw2 || obj._sumw2;
            var binErrors = obj.fBinEntries || obj._binEntries;
            var yErrorsP = [];
            for (var j = 0; j < nbins; j++) {
                var center = xmin + (xmax - xmin) * (j + 0.5) / nbins;
                var val = (arr && arr[j] != null) ? arr[j] : 0;
                rows.push([center, val]);
                var err = 0;
                if (sumw2 && sumw2[j] != null && sumw2[j] >= 0) err = Math.sqrt(sumw2[j]);
                else if (binErrors && binErrors[j] != null && binErrors[j] > 0 && val != null) err = Math.abs(val) / Math.sqrt(binErrors[j]);
                yErrorsP.push(err);
            }
            var outP = { headers: ['bin_center', 'content'], rows: rows };
            if (axisLabels) outP.axisLabels = axisLabels;
            outP.yErrors = yErrorsP;
            return outP;
        }

        if (tn.indexOf('th1') !== -1) {
            var arr = obj.fArray || obj._data || obj.array || [];
            var nbins = obj.fNbinsX || obj.fNcells || (arr && arr.length) || 0;
            var xmin = (obj.fXaxis && (obj.fXaxis.fXmin ?? obj.fXaxis._xmin)) != null ? (obj.fXaxis.fXmin ?? obj.fXaxis._xmin) : 0;
            var xmax = (obj.fXaxis && (obj.fXaxis.fXmax ?? obj.fXaxis._xmax)) != null ? (obj.fXaxis.fXmax ?? obj.fXaxis._xmax) : 1;
            if (nbins <= 0 && arr.length) nbins = arr.length;
            rows = [];
            var sumw2 = obj.fSumw2 || obj._sumw2;
            var hasSumw2 = sumw2 && Array.isArray(sumw2) && sumw2.length >= nbins;
            var yErrorsTH1;
            if (hasSumw2) yErrorsTH1 = [];
            for (var j = 0; j < nbins; j++) {
                var center = xmin + (xmax - xmin) * (j + 0.5) / nbins;
                var val = (arr && arr[j] != null) ? arr[j] : 0;
                rows.push([center, val]);
                if (hasSumw2) yErrorsTH1.push(sumw2[j] != null && sumw2[j] >= 0 ? Math.sqrt(sumw2[j]) : 0);
            }
            var out1 = { headers: ['bin_center', 'content'], rows: rows };
            if (axisLabels) out1.axisLabels = axisLabels;
            if (yErrorsTH1) out1.yErrors = yErrorsTH1;
            return out1;
        }

        if (tn.indexOf('th2') !== -1) {
            var ax = obj.fXaxis || obj.xaxis;
            var ay = obj.fYaxis || obj.yaxis;
            var a2d = obj.fArray || obj._data || [];
            var nx = (ax && (ax.fNbins != null ? ax.fNbins : ax._nbins)) || 0;
            var ny = (ay && (ay.fNbins != null ? ay.fNbins : ay._nbins)) || 0;
            if (nx > 0 && ny > 0 && a2d.length >= nx * ny) {
                var xmin = (ax.fXmin != null ? ax.fXmin : ax._xmin) || 0;
                var xmax = (ax.fXmax != null ? ax.fXmax : ax._xmax) || 1;
                var ymin = (ay.fXmin != null ? ay.fXmin : ay._xmin) != null ? (ay.fXmin != null ? ay.fXmin : ay._xmin) : 0;
                var ymax = (ay.fXmax != null ? ay.fXmax : ay._xmax) != null ? (ay.fXmax != null ? ay.fXmax : ay._xmax) : 1;
                var xEdges = [];
                for (var bx = 0; bx <= nx; bx++) xEdges.push(xmin + (xmax - xmin) * bx / nx);
                var yEdges = [];
                for (var by = 0; by <= ny; by++) yEdges.push(ymin + (ymax - ymin) * by / ny);
                var zArr = [];
                for (var by = 0; by < ny; by++) {
                    var row = [];
                    for (var bx = 0; bx < nx; bx++) row.push(a2d[by * nx + bx] != null ? a2d[by * nx + bx] : 0);
                    zArr.push(row);
                }
                var out2d = { headers: ['x', 'y'], rows: [], _rootHeatmap: { x: xEdges, y: yEdges, z: zArr }, axisLabels: axisLabels };
                return out2d;
            }
            var proj = obj.ProjectionX || obj.projectionX;
            if (typeof proj === 'function') {
                var p1 = proj.call(obj);
                return p1 ? rootObjectToParsedData(p1) : null;
            }
        }
        if (tn.indexOf('tf1') !== -1) {
            var xaxf = obj.fXaxis || obj.xaxis || {};
            var xminF = obj.fXmin != null ? obj.fXmin : (xaxf.fXmin != null ? xaxf.fXmin : (xaxf._xmin != null ? xaxf._xmin : 0));
            var xmaxF = obj.fXmax != null ? obj.fXmax : (xaxf.fXmax != null ? xaxf.fXmax : (xaxf._xmax != null ? xaxf._xmax : 1));
            if (!(xmaxF > xminF)) xmaxF = xminF + 1;
            var npxF = obj.fNpx != null ? Math.min(500, Math.max(20, Math.floor(obj.fNpx))) : 200;
            function evalTF1At(x) {
                if (typeof obj.eval === 'function') {
                    try { var v = obj.eval(x); if (typeof v === 'number' && isFinite(v)) return v; } catch (e0) { /* ignore */ }
                }
                if (typeof obj.Eval === 'function') {
                    try { var v2 = obj.Eval(x); if (typeof v2 === 'number' && isFinite(v2)) return v2; } catch (e1) { /* ignore */ }
                }
                if (typeof obj.compute === 'function') {
                    try { var v3 = obj.compute(x); if (typeof v3 === 'number' && isFinite(v3)) return v3; } catch (e2) { /* ignore */ }
                }
                return NaN;
            }
            rows = [];
            var fi;
            for (fi = 0; fi <= npxF; fi++) {
                var xf = xminF + (xmaxF - xminF) * fi / npxF;
                var yf = evalTF1At(xf);
                if (!isNaN(yf)) rows.push([xf, yf]);
            }
            if (rows.length === 0) return null;
            var outF1 = { headers: ['x', 'y'], rows: rows, isFit: true };
            var xlTF = getAxisLabel(obj.fXaxis || obj.xaxis);
            var ylTF = getAxisLabel(obj.fYaxis || obj.yaxis);
            var titleTF = obj.fTitle || obj._title;
            if (titleTF && typeof titleTF === 'string' && titleTF.trim()) ylTF = titleTF.trim();
            if (xlTF || ylTF) {
                outF1.axisLabels = {
                    x: formatPlotlyLatex(rootToLatex(xlTF || 'x')),
                    y: formatPlotlyLatex(rootToLatex(ylTF || 'y'))
                };
            }
            return outF1;
        }

        if (tn.indexOf('th3') !== -1) {
            var ax = obj.fXaxis || obj.xaxis;
            var ay = obj.fYaxis || obj.yaxis;
            var az = obj.fZaxis || obj.zaxis;
            var a3d = obj.fArray || obj._data || [];
            var nx = (ax && (ax.fNbins != null ? ax.fNbins : ax._nbins)) || 0;
            var ny = (ay && (ay.fNbins != null ? ay.fNbins : ay._nbins)) || 0;
            var nz = (az && (az.fNbins != null ? az.fNbins : az._nbins)) || 0;
            if (nx > 0 && ny > 0 && nz > 0 && a3d.length >= nx * ny * nz) {
                var xmin = (ax.fXmin != null ? ax.fXmin : ax._xmin) || 0;
                var xmax = (ax.fXmax != null ? ax.fXmax : ax._xmax) || 1;
                var ymin = (ay.fXmin != null ? ay.fXmin : ay._xmin) != null ? (ay.fXmin != null ? ay.fXmin : ay._xmin) : 0;
                var ymax = (ay.fXmax != null ? ay.fXmax : ay._xmax) != null ? (ay.fXmax != null ? ay.fXmax : ay._xmax) : 1;
                var zmin = (az.fXmin != null ? az.fXmin : az._xmin) != null ? (az.fXmin != null ? az.fXmin : az._xmin) : 0;
                var zmax = (az.fXmax != null ? az.fXmax : az._xmax) != null ? (az.fXmax != null ? az.fXmax : az._xmax) : 1;
                var xs = [], ys = [], zs = [], vals = [];
                var step = Math.max(1, Math.floor(Math.pow(nx * ny * nz, 1 / 3) / 15));
                for (var bz = 0; bz < nz; bz += step) {
                    for (var by = 0; by < ny; by += step) {
                        for (var bx = 0; bx < nx; bx += step) {
                            var idx = bz * nx * ny + by * nx + bx;
                            var v = a3d[idx] != null ? a3d[idx] : 0;
                            if (v === 0) continue;
                            xs.push(xmin + (xmax - xmin) * (bx + 0.5) / nx);
                            ys.push(ymin + (ymax - ymin) * (by + 0.5) / ny);
                            zs.push(zmin + (zmax - zmin) * (bz + 0.5) / nz);
                            vals.push(v);
                        }
                    }
                }
                if (xs.length === 0) return null;
                var out3d = { headers: ['x', 'y', 'z'], rows: [], _root3D: { x: xs, y: ys, z: zs, values: vals }, axisLabels: axisLabels };
                return out3d;
            }
            var proj = obj.Projection3D || obj.ProjectionX;
            if (typeof proj === 'function') {
                var p1 = proj.call(obj);
                return p1 ? rootObjectToParsedData(p1) : null;
            }
        }
        return null;
    }

    /** Full path inside file (no session prefix / cycle) for search, lowercased */
    function rootObjectPathForSearch(pathCycle) {
        if (pathCycle == null || pathCycle === '') return '';
        var s = String(pathCycle);
        var idx = s.indexOf('::');
        if (idx >= 0) s = s.slice(idx + 2);
        var semi = s.lastIndexOf(';');
        if (semi >= 0) s = s.slice(0, semi);
        return s.toLowerCase();
    }

    function rootNodeSearchHaystack(n) {
        var parts = [];
        var p = rootObjectPathForSearch(n.pathCycle);
        if (p) parts.push(p);
        if (n.name) parts.push(String(n.name));
        if (n.className) parts.push(String(n.className));
        return parts.join(' ').toLowerCase();
    }

    function filterRootTreeNodes(nodes, needle) {
        if (!nodes || !needle || !String(needle).trim()) return nodes;
        var q = String(needle).trim().toLowerCase();
        function matches(n) {
            return rootNodeSearchHaystack(n).indexOf(q) >= 0;
        }
        function walk(arr) {
            var out = [];
            arr.forEach(function (n) {
                if (n.isDir) {
                    var kids = n.children && n.children.length ? walk(n.children) : [];
                    var dirMatch = matches(n);
                    if (kids.length || dirMatch) {
                        var copy = Object.assign({}, n);
                        copy.children = kids;
                        copy.expanded = true;
                        out.push(copy);
                    }
                } else if (matches(n)) {
                    out.push(n);
                }
            });
            return out;
        }
        return walk(nodes);
    }

    function renderRootTreeFiltered() {
        if (!rootTreeContainer) return;
        var nodes = lastRootTreeForFilter;
        if (!nodes || !nodes.length) {
            renderRootTree([], rootTreeContainer);
            return;
        }
        var needle = rootTreeFilter && rootTreeFilter.value ? rootTreeFilter.value : '';
        renderRootTree(filterRootTreeNodes(nodes, needle), rootTreeContainer);
    }

    function renderRootTree(nodes, container) {
        if (!container) return;
        if (!nodes || nodes.length === 0) {
            container.innerHTML = '<div class="root-tree-placeholder">No plottable objects in this directory.</div>';
            return;
        }
        function renderList(arr) {
            var ul = document.createElement('ul');
            ul.className = 'root-tree-list';
            arr.forEach(function (n) {
                var li = document.createElement('li');
                li.className = n.isDir ? 'root-tree-dir' : 'root-tree-item';
                if (n.isDir) {
                    var toggle = document.createElement('button');
                    toggle.type = 'button';
                    toggle.className = 'root-tree-toggle';
                    toggle.setAttribute('aria-expanded', n.expanded ? 'true' : 'false');
                    toggle.textContent = n.expanded ? '\u25bc' : '\u25b6';
                    toggle.title = n.expanded ? 'Collapse' : 'Expand';
                    var kidUl = document.createElement('ul');
                    kidUl.className = 'root-tree-list';
                    kidUl.hidden = !n.expanded;
                    if (n.children && n.children.length) kidUl.appendChild(renderList(n.children));
                    toggle.addEventListener('click', function () {
                        n.expanded = !n.expanded;
                        kidUl.hidden = !n.expanded;
                        toggle.textContent = n.expanded ? '\u25bc' : '\u25b6';
                        toggle.setAttribute('aria-expanded', n.expanded ? 'true' : 'false');
                        toggle.title = n.expanded ? 'Collapse' : 'Expand';
                    });
                    var nameSpan = document.createElement('span');
                    nameSpan.className = 'root-tree-name root-tree-dir-name';
                    nameSpan.textContent = n.name + '/';
                    nameSpan.title = n.pathCycle;
                    li.appendChild(toggle);
                    li.appendChild(nameSpan);
                    li.appendChild(kidUl);
                } else {
                    var leaf = document.createElement('div');
                    leaf.className = 'root-tree-leaf';
                    var cb = document.createElement('input');
                    cb.type = 'checkbox';
                    cb.dataset.pathCycle = n.pathCycle;
                    cb.id = 'root-cb-' + String(n.pathCycle).replace(/[^a-zA-Z0-9_;/.-]/g, '_');
                    var lbl = document.createElement('label');
                    lbl.className = 'root-tree-name';
                    lbl.textContent = n.name;
                    lbl.title = n.pathCycle;
                    lbl.setAttribute('for', cb.id);
                    leaf.appendChild(cb);
                    leaf.appendChild(lbl);
                    li.appendChild(leaf);
                }
                ul.appendChild(li);
            });
            return ul;
        }
        container.innerHTML = '';
        container.appendChild(renderList(nodes));
    }

    function getSelectedRootPathCycles() {
        if (!rootTreeContainer) return [];
        var cbs = rootTreeContainer.querySelectorAll('input[type="checkbox"]:checked');
        return Array.prototype.map.call(cbs, function (el) { return el.dataset.pathCycle || ''; }).filter(Boolean);
    }

    /** @returns {{ sessionIndex: number, path: string, cycle: number }} */
    function parseRootPathCycle(pathCycle) {
        var s = (pathCycle || '').trim();
        var sessionIndex = 0;
        var rest = s;
        var sep = s.indexOf('::');
        if (sep >= 0) {
            sessionIndex = parseInt(s.slice(0, sep), 10);
            if (isNaN(sessionIndex)) sessionIndex = 0;
            rest = s.slice(sep + 2);
        }
        var semi = rest.lastIndexOf(';');
        var path = semi >= 0 ? rest.slice(0, semi) : rest;
        var cycle = semi >= 0 ? parseInt(rest.slice(semi + 1), 10) : 1;
        if (isNaN(cycle)) cycle = 1;
        return { sessionIndex: sessionIndex, path: path, cycle: cycle };
    }

    function resetRootPlot() {
        if (!rootTreeContainer) return;
        rootTreeContainer.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
        parsedData = null;
        if (currentChart) {
            if (typeof Plotly !== 'undefined' && plotDiv) Plotly.purge(plotDiv);
            currentChart = null;
        }
        lastPlotState = { traces: [], layout: {}, chartType: null };
        destroyRatioChart();
        if (xColumnList) xColumnList.innerHTML = '';
        if (yColumnList) yColumnList.innerHTML = '';
        if (previewTable) previewTable.innerHTML = '';
        if (previewTableContainer) previewTableContainer.hidden = true;
        var chartContainer = plotDiv && plotDiv.closest('.workspace-chart');
        if (chartContainer) chartContainer.classList.remove('visible');
        if (workspacePlaceholder) workspacePlaceholder.classList.remove('hidden');
        var rootOpt = document.getElementById('rootOptionsBlock');
        if (rootOpt) rootOpt.hidden = true;
        isRootData = false;
        clearMessage();
        showMessage('Selections and plot cleared.', false);
    }

    function clearPlotCanvasOnly(silent) {
        if (currentChart) {
            if (typeof Plotly !== 'undefined' && plotDiv) Plotly.purge(plotDiv);
            currentChart = null;
        }
        lastPlotState = { traces: [], layout: {}, chartType: null };
        destroyRatioChart();
        var chartContainer = plotDiv && plotDiv.closest('.workspace-chart');
        if (chartContainer) chartContainer.classList.remove('visible');
        if (workspacePlaceholder) workspacePlaceholder.classList.remove('hidden');
        clearMessage();
        if (!silent) showMessage('Plot cleared.', false);
    }

    function clearTextSelections() {
        document.querySelectorAll('input[name="yCol"]').forEach(function (el) { el.checked = false; });
        var firstX = document.querySelector('input[name="xCol"]');
        if (firstX) firstX.checked = true;
    }

    function clearAllSelectionsAndPlot() {
        if (leftPanelRoot && !leftPanelRoot.hidden && rootSessions.length) {
            resetRootPlot();
            return;
        }
        clearPlotCanvasOnly(true);
        if (parsedData && xColumnList && xColumnList.children.length) {
            clearTextSelections();
        }
        if (previewTable) previewTable.innerHTML = '';
        if (previewTableContainer) previewTableContainer.hidden = true;
        clearMessage();
        showMessage('Selections and plot cleared.', false);
    }

    function balanceWorkspacePanels() {
        var ws = document.getElementById('workspace');
        if (!ws) return;
        if (getComputedStyle(ws).display === 'none') return;
        ws.style.setProperty('--panel-left-w', '25%');
        ws.style.setProperty('--panel-right-w', '25%');
    }

    function mergeRootParsedData(payloads) {
        if (!payloads || payloads.length === 0) return null;
        var maxLen = 0;
        var i, p;
        for (i = 0; i < payloads.length; i++) {
            p = payloads[i];
            if (p && p.rows && p.rows.length > maxLen) maxLen = p.rows.length;
        }
        var headers = [];
        var rows = [];
        var yErrors = [];
        for (i = 0; i < payloads.length; i++) {
            var objName = (payloads[i].objectName != null && String(payloads[i].objectName).trim()) ? String(payloads[i].objectName).trim() : ('y_' + (i + 1));
            headers.push('x_' + (i + 1));
            headers.push(objName);
            yErrors.push(payloads[i].yErrors || null);
        }
        for (var r = 0; r < maxLen; r++) {
            var row = [];
            for (i = 0; i < payloads.length; i++) {
                p = payloads[i];
                var rr = p && p.rows && p.rows[r];
                row.push(rr && rr[0] != null ? rr[0] : null);
                row.push(rr && rr[1] != null ? rr[1] : null);
            }
            rows.push(row);
        }
        var out = { headers: headers, rows: rows };
        if (payloads[0] && payloads[0].axisLabels) out.axisLabels = payloads[0].axisLabels;
        if (yErrors.some(function (e) { return e != null; })) out.yErrors = yErrors;
        var seriesMeta = [];
        for (i = 0; i < payloads.length; i++) {
            seriesMeta.push({ isFit: !!(payloads[i] && payloads[i].isFit) });
        }
        out.seriesMeta = seriesMeta;
        return out;
    }

    function mergeRootTreesForDisplay(sessions) {
        if (!sessions || sessions.length === 0) return [];
        if (sessions.length === 1) return sessions[0].tree || [];
        return sessions.map(function (sess, idx) {
            var label = sess.fileName || ('File ' + (idx + 1));
            return { name: label, pathCycle: '', isDir: true, expanded: true, children: sess.tree || [], isFileGroup: true, sessionIndex: idx };
        });
    }

    function handleRootFiles(files, append) {
        if (!window.__JSROOT || !window.__JSROOT.openFile) {
            showMessage('ROOT support (JSROOT) is loading or failed. Reload the page and try again.', true);
            return;
        }
        if (!files || files.length === 0) return;
        if (rootFileUrl) URL.revokeObjectURL(rootFileUrl);
        rootFileUrl = null;
        if (!append) rootSessions = [];
        var startIdx = rootSessions.length;
        showMessage(files.length > 1 ? ('Opening ' + files.length + ' ROOT files…') : 'Opening ROOT file…', false);

        function tryBuildTree(f, dir, prefix, sessionIndex) {
            return buildRootTree(f, dir, prefix, sessionIndex).catch(function (err) {
                console.warn('buildRootTree failed:', err);
                return [];
            });
        }

        function openOneSession(file, sessionIndex) {
            var openArg = file;
            if (!openArg || typeof openArg.slice !== 'function') {
                return Promise.reject(new Error('Invalid file object for ROOT.'));
            }
            return window.__JSROOT.openFile(openArg).then(function (f) {
                return tryBuildTree(f, f, '', sessionIndex).then(function (tree) {
                    if (Array.isArray(tree) && tree.length > 0) return { fileName: file.name, file: f, tree: tree };
                    if (!f || typeof f.readDirectory !== 'function') return { fileName: file.name, file: f, tree: tree };
                    return f.readDirectory('').catch(function () {
                        return f.readDirectory('.').catch(function () { return null; });
                    }).then(function (rootDir) {
                        if (!rootDir || getKeysFromDir(rootDir).length === 0) return { fileName: file.name, file: f, tree: tree };
                        return tryBuildTree(f, rootDir, '', sessionIndex).then(function (tree2) {
                            return { fileName: file.name, file: f, tree: tree2 };
                        });
                    });
                }).then(function (sess) {
                    if (Array.isArray(sess.tree) && sess.tree.length > 0) return sess;
                    return collectAllKeyPathsRecursive(f, f, '').then(function (pathCycles) {
                        if (!pathCycles || pathCycles.length === 0) return sess;
                        sess.tree = pathCycles.map(function (pc) {
                            var name = pc.replace(/;\d+$/, '');
                            var lastSlash = name.lastIndexOf('/');
                            if (lastSlash >= 0) name = name.slice(lastSlash + 1);
                            return { name: name, pathCycle: sessionIndex + '::' + pc, isDir: false, className: '' };
                        });
                        return sess;
                    }).catch(function () { return sess; });
                });
            });
        }

        var tasks = [];
        var i;
        for (i = 0; i < files.length; i++) {
            tasks.push(openOneSession(files[i], startIdx + i));
        }
        Promise.all(tasks).then(function (sessions) {
            rootSessions = append ? rootSessions.concat(sessions) : sessions;
            clearMessage();
            var app = document.querySelector('.app');
            var ws = document.getElementById('workspace');
            if (app) app.classList.add('view-workspace');
            if (ws) ws.style.display = 'grid';
            requestAnimationFrame(function () { balanceWorkspacePanels(); });
            if (panelLeft) panelLeft.classList.add('root-mode');
            leftPanelRoot.hidden = false;
            leftPanelTxtDat.hidden = false;
            var tree = mergeRootTreesForDisplay(rootSessions);
            lastRootTreeForFilter = tree;
            if (Array.isArray(tree) && tree.length > 0) {
                renderRootTreeFiltered();
            } else {
                lastRootTreeForFilter = [];
                renderRootTree([], rootTreeContainer);
                showMessage('No plottable objects (TGraph, TH1, TH2, TH3, TProfile, TF1) found in ROOT file(s).', true);
            }
        }).catch(function (e) {
            showMessage('Failed to open ROOT file(s): ' + (e && e.message ? e.message : String(e)), true);
        });
    }

    function handleRootFile(file) {
        handleRootFiles([file], false);
    }

    function addRootSelectedToPlot() {
        var pathCycles = getSelectedRootPathCycles();
        if (!pathCycles.length) {
            showMessage('Select one or more objects (check the boxes) in the tree.', true);
            return;
        }
        if (!rootSessions.length) {
            showMessage('ROOT file not open.', true);
            return;
        }
        showMessage('Loading ' + pathCycles.length + ' object(s)…', false);
        var promises = pathCycles.map(function (pathCycle) {
            var pr = parseRootPathCycle(pathCycle);
            var rf = rootSessions[pr.sessionIndex] && rootSessions[pr.sessionIndex].file;
            if (!rf) {
                return Promise.reject(new Error('Missing file session ' + pr.sessionIndex));
            }
            var path = pr.path;
            var cycle = pr.cycle;
            if (typeof rf.readObject === 'function') {
                return rf.readObject(path, cycle).catch(function () { return rf.readObject(path + ';' + cycle); });
            }
            return rf.readObject(pathCycle);
        });
        Promise.all(promises).then(function (objs) {
            var payloads = [];
            var i;
            for (i = 0; i < objs.length; i++) {
                var pd = rootObjectToParsedData(objs[i]);
                if (!pd) continue;
                if (pd._rootHeatmap || pd._root3D || (pd.rows && pd.rows.length)) payloads.push(pd);
            }
            if (payloads.length === 0) {
                showMessage('Could not convert selected objects to plot data.', true);
                return;
            }
            for (i = 0; i < payloads.length; i++) {
                var pathCycle = pathCycles[i];
                var prn = parseRootPathCycle(pathCycle);
                var name = prn.path || '';
                var lastSlash = name.lastIndexOf('/');
                if (lastSlash >= 0) name = name.slice(lastSlash + 1);
                var sessn = rootSessions[prn.sessionIndex];
                if (sessn && sessn.fileName && rootSessions.length > 1) {
                    name = sessn.fileName.replace(/\.root$/i, '') + ':' + name;
                }
                payloads[i].objectName = name || ('Object ' + (i + 1));
            }
            var has2d3d = payloads.some(function (p) { return p._rootHeatmap || p._root3D; });
            if (has2d3d) {
                parsedData = payloads.find(function (p) { return p._rootHeatmap || p._root3D; }) || payloads[0];
            } else {
                parsedData = payloads.length === 1 ? payloads[0] : mergeRootParsedData(payloads);
            }
            if (payloads.length === 1 && payloads[0].objectName && parsedData.headers && parsedData.headers.length >= 2 && !parsedData._rootHeatmap && !parsedData._root3D) {
                parsedData.headers[1] = payloads[0].objectName;
            }
            if (parsedData && !parsedData._rootHeatmap && !parsedData._root3D && payloads.length === 1 && !parsedData.seriesMeta) {
                parsedData.seriesMeta = [{ isFit: !!payloads[0].isFit }];
            }
            if (!parsedData) {
                showMessage('No data to plot.', true);
                return;
            }
            if (!parsedData._rootHeatmap && !parsedData._root3D && (!parsedData.rows || !parsedData.rows.length)) {
                showMessage('No data to plot.', true);
                return;
            }
            isRootData = true;
            clearMessage();
            if (parsedData._rootHeatmap || parsedData._root3D) {
                leftPanelTxtDat.hidden = false;
                leftPanelRoot.hidden = false;
                if (panelLeft) panelLeft.classList.add('root-mode');
                var app = document.querySelector('.app');
                var ws = document.getElementById('workspace');
                if (app) app.classList.add('view-workspace');
                if (ws) ws.style.display = 'grid';
                requestAnimationFrame(function () { balanceWorkspacePanels(); });
                var chartContainer = plotDiv && plotDiv.closest('.workspace-chart');
                if (chartContainer) chartContainer.classList.add('visible');
                if (workspacePlaceholder) workspacePlaceholder.classList.add('hidden');
                buildChart();
                return;
            }
            fillColumnLists();
            renderPreview();
            var xIdx = 0;
            var yIndices = [];
            for (i = 0; i < (parsedData.headers.length / 2); i++) yIndices.push(2 * i + 1);
            var xRadio = document.querySelector('input[name="xCol"][value="' + xIdx + '"]');
            if (xRadio) xRadio.checked = true;
            document.querySelectorAll('input[name="yCol"]').forEach(function (el) {
                var v = parseInt(el.value, 10);
                el.checked = yIndices.indexOf(v) !== -1;
            });
            if (parsedData.axisLabels) {
                if (parsedData.axisLabels.x && xLabelEl) xLabelEl.value = parsedData.axisLabels.x;
                if (parsedData.axisLabels.y && yLabelEl) yLabelEl.value = parsedData.axisLabels.y;
            }
            var rootOpt = document.getElementById('rootOptionsBlock');
            if (rootOpt) rootOpt.hidden = false;
            renderPreview();
            leftPanelTxtDat.hidden = false;
            if (panelLeft) panelLeft.classList.add('root-mode');
            var app2 = document.querySelector('.app');
            var ws2 = document.getElementById('workspace');
            if (app2) app2.classList.add('view-workspace');
            if (ws2) ws2.style.display = 'grid';
            requestAnimationFrame(function () { balanceWorkspacePanels(); });
            var chartContainer1d = plotDiv && plotDiv.closest('.workspace-chart');
            if (chartContainer1d) chartContainer1d.classList.add('visible');
            if (workspacePlaceholder) workspacePlaceholder.classList.add('hidden');
            buildChart();
        }).catch(function (e) {
            showMessage('Failed to read object(s): ' + (e && e.message ? e.message : String(e)), true);
        });
    }

    function applyDelimiterAndRefresh() {
        const delim = delimiterSelect ? delimiterSelect.value : 'auto';
        parsedData = parseText(rawText, delim);
        if (!parsedData || parsedData.rows.length === 0) {
            showMessage('No numeric data found. Check delimiter or format.', true);
            return;
        }
        isRootData = false;
        var rootOpt = document.getElementById('rootOptionsBlock');
        if (rootOpt) rootOpt.hidden = true;
        var app = document.querySelector('.app');
        var ws = document.getElementById('workspace');
        if (app) app.classList.add('view-workspace');
        if (ws) ws.style.display = 'grid';
        requestAnimationFrame(function () { balanceWorkspacePanels(); });
        leftPanelTxtDat.hidden = false;
        leftPanelRoot.hidden = true;
        if (panelLeft) panelLeft.classList.remove('root-mode');
        fillColumnLists();
        renderPreview();
        clearMessage();
    }

    function fillColumnLists() {
        if (!parsedData) return;
        const { headers } = parsedData;
        xColumnList.innerHTML = headers.map((h, i) =>
            '<label class="column-item"><input type="radio" name="xCol" value="' + i + '"' + (i === 0 ? ' checked' : '') + '><span>' + escapeHtml(h) + '</span></label>'
        ).join('');
        yColumnList.innerHTML = headers.map((h, i) =>
            '<label class="column-item"><input type="checkbox" name="yCol" value="' + i + '"><span>' + escapeHtml(h) + '</span></label>'
        ).join('');
        if (pendingColumnConfig) {
            var xRadio = document.querySelector('input[name="xCol"][value="' + pendingColumnConfig.xColumn + '"]');
            if (xRadio) xRadio.checked = true;
            document.querySelectorAll('input[name="yCol"]').forEach(function (el) {
                el.checked = pendingColumnConfig.yColumns && pendingColumnConfig.yColumns.indexOf(parseInt(el.value, 10)) !== -1;
            });
            pendingColumnConfig = null;
        }
    }

    function renderPreview() {
        if (!parsedData || !previewTable) return;
        const { headers, rows } = parsedData;
        const slice = rows.slice(0, 15);
        let html = '<thead><tr>' + headers.map(h => '<th>' + escapeHtml(h) + '</th>').join('') + '</tr></thead><tbody>';
        slice.forEach(row => {
            html += '<tr>' + row.map(v => '<td>' + (v == null ? '' : escapeHtml(String(v))) + '</td>').join('') + '</tr>';
        });
        html += '</tbody>';
        if (rows.length > 15) html += '<tfoot><tr><td colspan="' + headers.length + '">… ' + (rows.length - 15) + ' more</td></tr></tfoot>';
        previewTable.innerHTML = html;
    }

    function getSelectedXIndex() {
        const r = document.querySelector('input[name="xCol"]:checked');
        return r ? parseInt(r.value, 10) : 0;
    }

    function getSelectedYIndices() {
        return Array.from(document.querySelectorAll('input[name="yCol"]:checked')).map(el => parseInt(el.value, 10));
    }

    // ========== CHART BUILD ==========
    function getScaleOptions() {
        const xLog = xLogScale && xLogScale.checked;
        const yLog = yLogScale && yLogScale.checked;
        return {
            x: {
                type: xLog ? 'logarithmic' : 'linear',
                title: { display: true, text: xLabelEl && xLabelEl.value ? xLabelEl.value : 'X' },
                min: xMinEl && xMinEl.value !== '' ? parseFloat(xMinEl.value) : undefined,
                max: xMaxEl && xMaxEl.value !== '' ? parseFloat(xMaxEl.value) : undefined
            },
            y: {
                type: yLog ? 'logarithmic' : 'linear',
                beginAtZero: !yLog,
                title: { display: true, text: yLabelEl && yLabelEl.value ? yLabelEl.value : 'Y' },
                min: yMinEl && yMinEl.value !== '' ? parseFloat(yMinEl.value) : undefined,
                max: yMaxEl && yMaxEl.value !== '' ? parseFloat(yMaxEl.value) : undefined
            }
        };
    }

    /** Read Plotly-computed major tick step for linear axes (fallback from range if needed). */
    function inferMajorDtickFromFullAxis(fa) {
        if (!fa || fa.type !== 'linear') return null;
        var dt = fa.dtick;
        var t0 = fa.tick0;
        if (dt != null && isFinite(dt) && dt > 0) {
            return { dt: dt, t0: (t0 != null && isFinite(t0)) ? t0 : 0 };
        }
        var r = fa.range;
        if (!r || r.length < 2) return null;
        var a = r[0], b = r[1];
        if (!isFinite(a) || !isFinite(b)) return null;
        var span = Math.abs(b - a);
        var nt = fa.nticks;
        if (nt == null || nt < 2) nt = 6;
        var tdEl = document.getElementById('tickDivisions');
        var td = tdEl && tdEl.value !== '' ? parseInt(tdEl.value, 10) : NaN;
        if (!isNaN(td) && td >= 2) nt = td;
        var est = span / Math.max(1, nt - 1);
        if (!isFinite(est) || est <= 0) return null;
        return { dt: est, t0: Math.min(a, b) };
    }

    /**
     * After Plotly picks major ticks, set minor.dtick so exactly #subTicks minor marks fall between majors:
     * minor step = major_dtick / (nSub + 1).
     */
    function syncMinorDtickAfterPlot() {
        if (minorDtickSyncInProgress || !plotDiv || typeof Plotly === 'undefined' || !currentChart) return;
        if (!lastPlotState || !lastPlotState.layout || !lastPlotState.traces || !lastPlotState.traces.length) return;
        var stEl = document.getElementById('subTicks');
        var nSub = stEl ? parseInt(stEl.value, 10) : 0;
        if (isNaN(nSub) || nSub <= 0) {
            lastMinorDtickSyncSig = '';
            return;
        }
        var full = plotDiv._fullLayout;
        if (!full) return;
        var layout = lastPlotState.layout;
        var relayoutPatch = {};
        var sigParts = [];

        function considerKey(key) {
            if (!(key === 'xaxis' || /^xaxis\d+$/.test(key) || key === 'yaxis' || /^yaxis\d+$/.test(key))) return;
            var fa = full[key];
            if (!fa || fa.type !== 'linear') return;
            var inf = inferMajorDtickFromFullAxis(fa);
            if (!inf || !inf.dt || inf.dt <= 0) return;
            var minorDt = inf.dt / (nSub + 1);
            sigParts.push(key + ':' + minorDt.toExponential(8) + ':' + inf.t0);
            relayoutPatch[key + '.minor.dtick'] = minorDt;
            relayoutPatch[key + '.minor.tick0'] = inf.t0;
            if (layout[key]) {
                layout[key].minor = layout[key].minor || {};
                layout[key].minor.dtick = minorDt;
                layout[key].minor.tick0 = inf.t0;
            }
        }

        Object.keys(layout).forEach(considerKey);
        var sig = sigParts.sort().join('|');
        if (sig === lastMinorDtickSyncSig || Object.keys(relayoutPatch).length === 0) return;
        lastMinorDtickSyncSig = sig;
        minorDtickSyncInProgress = true;
        try {
            Plotly.relayout(plotDiv, relayoutPatch);
        } finally {
            minorDtickSyncInProgress = false;
        }
    }

    /** Plotly only adds `.on` to the graph div after the first draw; chain sync from newPlot/react promises instead. */
    function chainPlotlyAfterDraw(maybePromise) {
        if (maybePromise && typeof maybePromise.then === 'function') {
            maybePromise.then(function () { syncMinorDtickAfterPlot(); }).catch(function () {});
        } else {
            setTimeout(function () { syncMinorDtickAfterPlot(); }, 0);
        }
    }

    /**
     * Full plot-area frame (showline + mirror allticks) and major/minor ticks from Style
     * (#tickDivisions max ticks, #subTicks = subticks between each pair of majors).
     */
    function getPlotlyAxisFrameAndTickOpts(isX, axisType, showGrid, yZeroline) {
        var tdEl = document.getElementById('tickDivisions');
        var stEl = document.getElementById('subTicks');
        var tSize = tickSize && tickSize.value ? parseInt(tickSize.value, 10) : 11;
        if (isNaN(tSize) || tSize < 8) tSize = 11;
        var tickLen = Math.max(4, Math.round(tSize * 0.45));
        var minorTickLen = Math.max(2, Math.round(tSize * 0.38));
        var o = {
            showline: true,
            mirror: 'allticks',
            linewidth: 1,
            linecolor: ROOT_STYLE.axisColor,
            ticks: 'inside',
            ticklen: tickLen,
            tickwidth: 1,
            tickcolor: ROOT_STYLE.tickColor,
            zeroline: isX ? false : yZeroline
        };
        var td = tdEl && tdEl.value !== '' ? parseInt(tdEl.value, 10) : NaN;
        if (!isNaN(td) && td >= 2 && td <= 50) o.nticks = td;
        var st = stEl ? parseInt(stEl.value, 10) : 0;
        if (axisType === 'log') {
            if (!isNaN(st) && st > 0) {
                o.minor = {
                    showgrid: showGrid,
                    gridcolor: ROOT_STYLE.gridColor,
                    griddash: 'dot',
                    ticks: 'inside',
                    ticklen: minorTickLen,
                    tickcolor: ROOT_STYLE.tickColor
                };
            }
            return o;
        }
        if (!isNaN(st) && st > 0) {
            o.minor = {
                showgrid: showGrid,
                gridcolor: ROOT_STYLE.gridColor,
                gridwidth: 1,
                griddash: 'dot',
                ticks: 'inside',
                ticklen: minorTickLen,
                tickcolor: ROOT_STYLE.tickColor
            };
        }
        return o;
    }

    function applyAxisFrameAndTicksToLayout() {
        if (!lastPlotState || !lastPlotState.layout) return;
        var l = lastPlotState.layout;
        var gX = document.getElementById('gridX');
        var gY = document.getElementById('gridY');
        var xLogEl = document.getElementById('xLogScale');
        var yLogEl = document.getElementById('yLogScale');
        var showGridX = gX ? gX.checked : false;
        var showGridY = gY ? gY.checked : false;
        var xLog = xLogEl && xLogEl.checked;
        var yLog = yLogEl && yLogEl.checked;
        var stEl = document.getElementById('subTicks');
        var st = stEl ? parseInt(stEl.value, 10) : 0;
        var clearMinor = isNaN(st) || st <= 0;
        var ratioY2 = l.xaxis && l.xaxis.anchor === 'y2';
        function mergeAxis(key, isX) {
            var ax = l[key];
            if (!ax || typeof ax !== 'object') return;
            var t = ax.type === 'log' ? 'log' : 'linear';
            var grid = isX ? showGridX : showGridY;
            var zl;
            if (isX) zl = false;
            else if (key === 'yaxis2' && ratioY2) zl = true;
            else zl = !yLog;
            var savedDtick = null;
            var savedTick0 = null;
            if (!clearMinor && ax.minor && ax.minor.dtick != null) {
                savedDtick = ax.minor.dtick;
                savedTick0 = ax.minor.tick0;
            }
            var patch = getPlotlyAxisFrameAndTickOpts(isX, t, grid, zl);
            Object.assign(ax, patch);
            if (clearMinor) {
                if (ax.minor) delete ax.minor;
            } else if (savedDtick != null) {
                ax.minor = ax.minor || {};
                ax.minor.dtick = savedDtick;
                if (savedTick0 != null) ax.minor.tick0 = savedTick0;
            }
        }
        Object.keys(l).forEach(function (key) {
            if (key === 'xaxis' || /^xaxis[0-9]+$/.test(key)) mergeAxis(key, true);
        });
        Object.keys(l).forEach(function (key) {
            if (key === 'yaxis' || /^yaxis[0-9]+$/.test(key)) mergeAxis(key, false);
        });
    }

    function getSeriesYErrors(seriesIndex) {
        if (!parsedData || !parsedData.yErrors) return null;
        var ye = parsedData.yErrors;
        if (Array.isArray(ye[0])) return ye[seriesIndex] || null;
        return seriesIndex === 0 ? ye : null;
    }

    function syncRatioToggleButton() {
        var btn = document.getElementById('toggleRatioBtn');
        if (!btn) return;
        var yc = typeof getSelectedYIndices === 'function' ? getSelectedYIndices() : [];
        var hasTwo = Array.isArray(yc) && yc.length >= 2;
        btn.disabled = !hasTwo;
        btn.textContent = ratioPanelActive ? 'Hide ratio plot' : 'Show ratio plot';
    }

    function updateRatioControls(yIndices, headers) {
        if (!ratioNumeratorSelect || !ratioDenominatorSelect) return;
        var hasTwo = Array.isArray(yIndices) && yIndices.length >= 2;
        if (!hasTwo) {
            ratioPanelActive = false;
            ratioNumeratorSelect.disabled = true;
            ratioDenominatorSelect.disabled = true;
            syncRatioToggleButton();
            return;
        }
        ratioNumeratorSelect.disabled = false;
        ratioDenominatorSelect.disabled = false;
        var prevNum = ratioNumeratorSelect.value;
        var prevDen = ratioDenominatorSelect.value;
        ratioNumeratorSelect.innerHTML = '';
        ratioDenominatorSelect.innerHTML = '';
        yIndices.forEach(function (yIdx, i) {
            var label = headers && headers[yIdx] != null ? headers[yIdx] : ('Series ' + (i + 1));
            var val = String(i);
            var optN = document.createElement('option');
            optN.value = val;
            optN.textContent = label;
            ratioNumeratorSelect.appendChild(optN);
            var optD = document.createElement('option');
            optD.value = val;
            optD.textContent = label;
            ratioDenominatorSelect.appendChild(optD);
        });
        if (prevNum !== '' && parseInt(prevNum, 10) < yIndices.length) {
            ratioNumeratorSelect.value = prevNum;
        } else {
            ratioNumeratorSelect.value = '0';
        }
        if (prevDen !== '' && parseInt(prevDen, 10) < yIndices.length && prevDen !== ratioNumeratorSelect.value) {
            ratioDenominatorSelect.value = prevDen;
        } else {
            ratioDenominatorSelect.value = yIndices.length > 1 ? '1' : '0';
        }
        if (ratioDenominatorSelect.value === ratioNumeratorSelect.value && yIndices.length > 1) {
            ratioDenominatorSelect.value = ratioNumeratorSelect.value === '0' ? '1' : '0';
        }
        syncRatioToggleButton();
    }

    function getPanelLayout() {
        var rowsEl = document.getElementById('panelRows');
        var colsEl = document.getElementById('panelCols');
        var rows = 1, cols = 1;
        if (rowsEl && rowsEl.value !== '') { rows = parseInt(rowsEl.value, 10); }
        if (colsEl && colsEl.value !== '') { cols = parseInt(colsEl.value, 10); }
        if (isNaN(rows) || rows < 1) rows = 1;
        if (rows > 6) rows = 6;
        if (isNaN(cols) || cols < 1) cols = 1;
        if (cols > 6) cols = 6;
        return { rows: rows, cols: cols };
    }

    function getCanvasSize() {
        var w = (canvasWidthEl && canvasWidthEl.value !== '') ? parseInt(canvasWidthEl.value, 10) : null;
        var h = (canvasHeightEl && canvasHeightEl.value !== '') ? parseInt(canvasHeightEl.value, 10) : null;
        if (w != null && (isNaN(w) || w < 200)) w = 200;
        if (w != null && w > 4000) w = 4000;
        if (h != null && (isNaN(h) || h < 200)) h = 200;
        if (h != null && h > 4000) h = 4000;
        return { width: w, height: h };
    }

    function applyCanvasSizeToContainer() {
        if (!plotContainer) return;
        var size = getCanvasSize();
        if (size.width != null && size.height != null) {
            plotContainer.classList.add('canvas-custom-size');
            plotContainer.style.width = size.width + 'px';
            plotContainer.style.height = size.height + 'px';
        } else {
            plotContainer.classList.remove('canvas-custom-size');
            plotContainer.style.width = '';
            plotContainer.style.height = '';
        }
    }

    function fillPanelAssignment(headers, yIndices) {
        if (!panelAssignmentContainer) return;
        var pl = getPanelLayout();
        var n = pl.rows * pl.cols;
        if (n <= 1) {
            panelAssignmentContainer.hidden = true;
            panelAssignmentContainer.innerHTML = '';
            return;
        }
        var seriesLabels = (yIndices && headers) ? yIndices.map(function (idx) { return headers[idx] || ''; }) : [];
        var numSeries = seriesLabels.length;
        var prevByPanel = [];
        var prevRows = panelAssignmentContainer.querySelectorAll('.panel-assign-row');
        var hadNoPrevUi = prevRows.length === 0;
        for (var pr = 0; pr < prevRows.length; pr++) {
            var picked = [];
            prevRows[pr].querySelectorAll('input.panel-series-cb[type="checkbox"]').forEach(function (cb) {
                if (cb.checked) {
                    var si = parseInt(cb.dataset.seriesIndex, 10);
                    if (si >= 0 && si < numSeries) picked.push(si);
                }
            });
            prevByPanel.push(picked);
        }
        panelAssignmentContainer.hidden = false;
        panelAssignmentContainer.innerHTML = '';
        for (var i = 0; i < n; i++) {
            var row = document.createElement('div');
            row.className = 'field panel-assign-row';
            row.id = 'panelAssignRow' + i;
            var title = document.createElement('label');
            title.textContent = 'Panel ' + (i + 1);
            row.appendChild(title);
            var picks = document.createElement('div');
            picks.className = 'panel-series-picks';
            for (var j = 0; j < numSeries; j++) {
                var lab = document.createElement('label');
                lab.className = 'checkbox-label';
                var cb = document.createElement('input');
                cb.type = 'checkbox';
                cb.className = 'panel-series-cb';
                cb.dataset.seriesIndex = String(j);
                cb.dataset.panelIndex = String(i);
                var shortLabel = 'S' + (j + 1) + (seriesLabels[j] ? ' (' + seriesLabels[j] + ')' : '');
                if (prevByPanel[i] && prevByPanel[i].indexOf(j) >= 0) {
                    cb.checked = true;
                } else if (hadNoPrevUi && i === 0 && j === 0 && numSeries > 0) {
                    cb.checked = true;
                }
                lab.appendChild(cb);
                lab.appendChild(document.createTextNode(shortLabel));
                picks.appendChild(lab);
            }
            row.appendChild(picks);
            panelAssignmentContainer.appendChild(row);
        }
        if (!panelAssignmentContainer.dataset.assignChangeBound) {
            panelAssignmentContainer.dataset.assignChangeBound = '1';
            panelAssignmentContainer.addEventListener('change', function (ev) {
                if (ev.target && ev.target.classList && ev.target.classList.contains('panel-series-cb') && parsedData) buildChart();
            });
        }
    }

    /** Per panel: list of dataset indices (0..numSeries-1) to draw; deduped, sorted. */
    function getPanelAssignment(numPanels, numSeries) {
        var out = [];
        for (var i = 0; i < numPanels; i++) {
            var row = document.getElementById('panelAssignRow' + i);
            var seen = {};
            var indices = [];
            if (row) {
                row.querySelectorAll('input.panel-series-cb[type="checkbox"]').forEach(function (cb) {
                    if (!cb.checked) return;
                    var si = parseInt(cb.dataset.seriesIndex, 10);
                    if (si < 0 || si >= numSeries || seen[si]) return;
                    seen[si] = true;
                    indices.push(si);
                });
            }
            indices.sort(function (a, b) { return a - b; });
            out.push(indices);
        }
        return out;
    }

    function destroyRatioChart() {
        ratioChart = null;
    }

    function buildRootHeatmap() {
        var hm = parsedData._rootHeatmap;
        if (!hm || !hm.x || !hm.y || !hm.z || !plotDiv || typeof Plotly === 'undefined') return;
        if (currentChart) Plotly.purge(plotDiv);
        currentChart = null;
        var chartContainer = plotDiv.closest('.workspace-chart');
        if (chartContainer) chartContainer.classList.add('visible');
        applyCanvasSizeToContainer();
        if (workspacePlaceholder) workspacePlaceholder.classList.add('hidden');
        var xTitle = formatPlotlyLatex((parsedData.axisLabels && parsedData.axisLabels.x) ? parsedData.axisLabels.x : 'x');
        var yTitle = formatPlotlyLatex((parsedData.axisLabels && parsedData.axisLabels.y) ? parsedData.axisLabels.y : 'y');
        var gX = document.getElementById('gridX');
        var gY = document.getElementById('gridY');
        var showGridX = gX ? gX.checked : false;
        var showGridY = gY ? gY.checked : false;
        var tickSz = tickSize && tickSize.value ? parseInt(tickSize.value, 10) : 11;
        var axisSz = axisLabelSize && axisLabelSize.value ? parseInt(axisLabelSize.value, 10) : 12;
        var trace = { z: hm.z, x: hm.x, y: hm.y, type: 'heatmap', colorscale: 'Viridis' };
        var layout = {
            xaxis: Object.assign({}, getPlotlyAxisFrameAndTickOpts(true, 'linear', showGridX, false), {
                title: { text: xTitle, font: { size: axisSz, family: ROOT_STYLE.fontFamily } },
                type: 'linear',
                showgrid: showGridX,
                gridcolor: ROOT_STYLE.gridColor,
                tickfont: { size: tickSz, family: ROOT_STYLE.fontFamily, color: ROOT_STYLE.tickColor }
            }),
            yaxis: Object.assign({}, getPlotlyAxisFrameAndTickOpts(false, 'linear', showGridY, true), {
                title: { text: yTitle, font: { size: axisSz, family: ROOT_STYLE.fontFamily } },
                type: 'linear',
                showgrid: showGridY,
                gridcolor: ROOT_STYLE.gridColor,
                tickfont: { size: tickSz, family: ROOT_STYLE.fontFamily, color: ROOT_STYLE.tickColor }
            }),
            margin: { t: 50, b: 50, l: 55, r: 40 },
            paper_bgcolor: ROOT_STYLE.canvasBg,
            plot_bgcolor: ROOT_STYLE.canvasBg,
            autosize: true
        };
        var canvasSize = getCanvasSize();
        if (canvasSize.width != null && canvasSize.height != null) {
            layout.width = canvasSize.width;
            layout.height = canvasSize.height;
            layout.autosize = false;
        }
        lastPlotState = { traces: [trace], layout: layout, chartType: 'heatmap' };
        currentChart = true;
        var useAutosize = canvasSize.width == null || canvasSize.height == null;
        lastMinorDtickSyncSig = '';
        chainPlotlyAfterDraw(Plotly.newPlot(plotDiv, [trace], layout, { responsive: useAutosize, autosize: useAutosize, displayModeBar: true, displaylogo: false }));
        destroyRatioChart();
        clearMessage();
    }

    function buildRoot3D() {
        var d3 = parsedData._root3D;
        if (!d3 || !d3.x || !d3.y || !d3.z || !plotDiv || typeof Plotly === 'undefined') return;
        if (currentChart) Plotly.purge(plotDiv);
        currentChart = null;
        var chartContainer = plotDiv.closest('.workspace-chart');
        if (chartContainer) chartContainer.classList.add('visible');
        applyCanvasSizeToContainer();
        if (workspacePlaceholder) workspacePlaceholder.classList.add('hidden');
        var trace = {
            x: d3.x,
            y: d3.y,
            z: d3.z,
            mode: 'markers',
            type: 'scatter3d',
            marker: { size: 2, color: d3.values, colorscale: 'Viridis', showscale: true }
        };
        var layout = {
            margin: { t: 30, b: 20, l: 20, r: 80 },
            scene: {
                xaxis: { title: 'x' },
                yaxis: { title: 'y' },
                zaxis: { title: 'z' },
                aspectmode: 'data'
            },
            paper_bgcolor: ROOT_STYLE.canvasBg,
            autosize: true
        };
        if (parsedData.axisLabels) {
            if (parsedData.axisLabels.x) layout.scene.xaxis.title = formatPlotlyLatex(parsedData.axisLabels.x);
            if (parsedData.axisLabels.y) layout.scene.yaxis.title = formatPlotlyLatex(parsedData.axisLabels.y);
            if (parsedData.axisLabels.z) layout.scene.zaxis.title = formatPlotlyLatex(parsedData.axisLabels.z);
        }
        var canvasSize = getCanvasSize();
        if (canvasSize.width != null && canvasSize.height != null) {
            layout.width = canvasSize.width;
            layout.height = canvasSize.height;
            layout.autosize = false;
        }
        lastPlotState = { traces: [trace], layout: layout, chartType: 'scatter3d' };
        currentChart = true;
        var useAutosize = canvasSize.width == null || canvasSize.height == null;
        lastMinorDtickSyncSig = '';
        chainPlotlyAfterDraw(Plotly.newPlot(plotDiv, [trace], layout, { responsive: useAutosize, autosize: useAutosize, displayModeBar: true, displaylogo: false }));
        destroyRatioChart();
        clearMessage();
    }

    function buildChart() {
        if (!parsedData) return;
        if (parsedData._rootHeatmap) {
            buildRootHeatmap();
            return;
        }
        if (parsedData._root3D) {
            buildRoot3D();
            return;
        }
        const xIdx = getSelectedXIndex();
        const yIndices = getSelectedYIndices();
        if (yIndices.length === 0) {
            showMessage('Select at least one Y column.', true);
            return;
        }
        const { headers, rows } = parsedData;
        updateRatioControls(yIndices, headers);
        const labels = rows.map(r => r[xIdx] != null ? String(r[xIdx]) : null);
        var baseType = chartTypeSelect.value === 'bar' ? 'bar' : chartTypeSelect.value === 'scatter' ? 'scatter' : 'line';
        var hasAnyErrors = false;
        for (var ei = 0; ei < yIndices.length; ei++) {
            if (getSeriesYErrors(ei)) { hasAnyErrors = true; break; }
        }
        var type = baseType;
        var plotShowLineEl = document.getElementById('plotShowLine');
        var plotShowMarkersEl = document.getElementById('plotShowMarkers');
        var wantLine = type !== 'bar' && plotShowLineEl && plotShowLineEl.checked;
        var wantMarkers = type !== 'bar' && plotShowMarkersEl && plotShowMarkersEl.checked;
        if (type === 'line' && !plotShowLineEl) wantLine = true;
        if (type === 'scatter' && !plotShowMarkersEl) wantMarkers = true;
        var scatterLineW = (lineWidthScatter && lineWidthScatter.value) ? parseInt(lineWidthScatter.value, 10) : 2;
        if (isNaN(scatterLineW) || scatterLineW < 1) scatterLineW = 2;
        var seriesLabel = function (h) { return (isRootData && h) ? rootToUnicode(h) : h; };
        var seriesMetaList = parsedData.seriesMeta;
        const datasets = yIndices.map((yIdx, i) => {
            const color = DEFAULT_COLORS[i % DEFAULT_COLORS.length];
            var meta = seriesMetaList && seriesMetaList[i] ? seriesMetaList[i] : {};
            var isFit = meta.isFit === true;
            var effWantLine = isFit ? true : wantLine;
            var effWantMarkers = isFit ? false : wantMarkers;
            var defaultSym = (type === 'scatter' && yIndices.length > 1)
                ? DEFAULT_SCATTER_MARKERS[i % DEFAULT_SCATTER_MARKERS.length]
                : 'circle';
            var seriesErr = getSeriesYErrors(i);
            var useErrorBars = seriesErr && seriesErr.length > 0;
            if (type === 'bar') {
                return {
                    label: seriesLabel(headers[yIdx]),
                    data: rows.map(r => r[yIdx] != null ? r[yIdx] : null),
                    borderColor: color,
                    backgroundColor: color + '99',
                    borderDash: []
                };
            }
            var pts;
            if (useErrorBars) {
                pts = rows.map(function (r, ri) {
                    if (r[xIdx] == null || r[yIdx] == null) return null;
                    var y = Number(r[yIdx]);
                    var ey = (seriesErr[ri] != null && !isNaN(seriesErr[ri])) ? Math.abs(Number(seriesErr[ri])) : 0;
                    return { x: r[xIdx], y: y, yMin: y - ey, yMax: y + ey };
                }).filter(function (p) { return p != null; });
            } else {
                pts = rows
                    .map(r => (r[xIdx] != null && r[yIdx] != null) ? { x: r[xIdx], y: r[yIdx] } : null)
                    .filter(p => p != null);
            }
            return {
                label: seriesLabel(headers[yIdx]),
                data: pts,
                borderColor: color,
                backgroundColor: color + '33',
                fill: false,
                tension: effWantLine ? 0.2 : 0,
                pointBackgroundColor: color,
                pointBorderColor: color,
                pointStyle: defaultSym,
                borderDash: [],
                borderWidth: scatterLineW,
                showLine: effWantLine,
                pointRadius: effWantMarkers ? 8 : 0,
                isFit: isFit,
                seriesIndex: i
            };
        });

        var rootNormalizeEl = document.getElementById('rootNormalize');
        var rootStackEl = document.getElementById('rootStack');
        var doNormalize = isRootData && rootNormalizeEl && rootNormalizeEl.checked;
        var doStack = isRootData && rootStackEl && rootStackEl.checked;

        if (doNormalize && datasets.length) {
            if (type === 'bar') {
                var xVals = rows.map(function (r) { return r[xIdx]; });
                var dx = 1;
                if (xVals.length >= 2) {
                    var xMin = Math.min.apply(null, xVals.filter(function (v) { return v != null && !isNaN(v); }));
                    var xMax = Math.max.apply(null, xVals.filter(function (v) { return v != null && !isNaN(v); }));
                    if (xMax > xMin) dx = (xMax - xMin) / (xVals.length - 1) || 1;
                }
                datasets.forEach(function (ds) {
                    var arr = ds.data;
                    var sum = 0;
                    for (var j = 0; j < arr.length; j++) if (arr[j] != null && !isNaN(arr[j])) sum += arr[j];
                    var scale = (sum * dx) > 0 ? 1 / (sum * dx) : 1;
                    ds.data = arr.map(function (v) { return v != null ? v * scale : null; });
                });
            } else {
                datasets.forEach(function (ds) {
                    var pts = ds.data;
                    if (!pts || pts.length < 2) return;
                    var area = 0;
                    for (var j = 0; j < pts.length - 1; j++) {
                        var x0 = pts[j].x, x1 = pts[j + 1].x, y0 = pts[j].y, y1 = pts[j + 1].y;
                        if (x0 != null && x1 != null && y0 != null && y1 != null)
                            area += (y0 + y1) * 0.5 * (Number(x1) - Number(x0));
                    }
                    if (Math.abs(area) < 1e-30) return;
                    var s = 1 / area;
                    ds.data = pts.map(function (p) {
                        var out = { x: p.x, y: p.y != null ? p.y * s : null };
                        if (p.yMin != null) out.yMin = p.yMin * s;
                        if (p.yMax != null) out.yMax = p.yMax * s;
                        return out;
                    });
                });
            }
        }

        if (doStack && datasets.length) {
            datasets.forEach(function (ds, idx) { ds.stack = 'stack0'; });
        }

        if (currentChart && typeof Plotly !== 'undefined' && plotDiv) Plotly.purge(plotDiv);
        currentChart = null;
        const chartContainer = plotDiv && plotDiv.closest('.workspace-chart');
        if (chartContainer) chartContainer.classList.add('visible');
        applyCanvasSizeToContainer();
        if (workspacePlaceholder) workspacePlaceholder.classList.add('hidden');

        const scaleOpts = getScaleOptions();
        if (xLabelEl && !String(xLabelEl.value || '').trim() && headers[xIdx]) xLabelEl.value = headers[xIdx];
        if (yLabelEl && !String(yLabelEl.value || '').trim()) yLabelEl.value = 'Y';
        var xTitleRaw = (xLabelEl && xLabelEl.value) ? xLabelEl.value : (headers[xIdx] || 'X');
        var yTitleRaw = (yLabelEl && yLabelEl.value) ? yLabelEl.value : 'Y';
        var xTitle = formatPlotlyLatex(xTitleRaw);
        var yTitle = formatPlotlyLatex(yTitleRaw);

        var pl = getPanelLayout();
        var nPanels = pl.rows * pl.cols;
        var useMultigraph = nPanels > 1;
        if (nPanels > 1) fillPanelAssignment(headers, yIndices);
        var panelAssign = nPanels > 1 ? getPanelAssignment(nPanels, datasets.length) : [];
        if (useMultigraph) {
            var nAssigned = 0;
            for (var pa = 0; pa < nPanels; pa++) {
                if (panelAssign[pa] && panelAssign[pa].length > 0) nAssigned++;
            }
            if (nAssigned === 0) {
                showMessage('Assign at least one Y series to at least one panel (use the checkboxes under Panel layout).', true);
                return;
            }
        }

        var axisSize = axisLabelSize && axisLabelSize.value ? parseInt(axisLabelSize.value, 10) : 12;
        var tickSz = tickSize && tickSize.value ? parseInt(tickSize.value, 10) : 11;
        var showGridX = gridX ? gridX.checked : false;
        var showGridY = gridY ? gridY.checked : false;

        var traces = [];

        function tracesFromDataset(ds, i) {
            var color = ds.borderColor || DEFAULT_COLORS[i % DEFAULT_COLORS.length];
            var si = ds.seriesIndex != null ? ds.seriesIndex : i;
            if (type === 'bar') {
                return [{
                    x: labels,
                    y: ds.data,
                    name: ds.label || ('Series ' + (i + 1)),
                    type: 'bar',
                    marker: { color: color },
                    _seriesIndex: si,
                    _seriesRole: 'main'
                }];
            }
            var effWantLine = ds.isFit ? true : wantLine;
            var effWantMarkers = ds.isFit ? false : wantMarkers;
            var xs = [], ys = [], errY = [];
            var hasErr = false;
            (ds.data || []).forEach(function (p) {
                if (p != null && typeof p === 'object') {
                    xs.push(p.x);
                    ys.push(p.y);
                    if (p.yMin != null && p.yMax != null) {
                        var ey = (Number(p.yMax) - Number(p.yMin)) / 2;
                        errY.push(ey);
                        hasErr = true;
                    } else {
                        errY.push(0);
                    }
                }
            });
            var plotMode = effWantLine && effWantMarkers ? 'lines+markers' : (effWantLine ? 'lines' : 'markers');
            var sym = (ds.pointStyle && ds.pointStyle !== 'circle') ? ds.pointStyle : 'circle';
            var mkSize = ds.pointRadius != null ? ds.pointRadius : (effWantMarkers ? 8 : 0);

            if (hasErr && (ds.isFit || effWantLine)) {
                var yUpper = ys.map(function (y, j) { return Number(y) + errY[j]; });
                var yLower = ys.map(function (y, j) { return Number(y) - errY[j]; });
                var bandTrace = {
                    type: 'scatter',
                    x: xs.concat(xs.slice().reverse()),
                    y: yUpper.concat(yLower.slice().reverse()),
                    fill: 'toself',
                    fillcolor: hexToRgba(color, 0.22),
                    line: { color: 'transparent' },
                    name: ds.label || ('Series ' + (i + 1)),
                    showlegend: false,
                    hoverinfo: 'skip',
                    legendgroup: 'series' + si,
                    _seriesIndex: si,
                    _seriesRole: 'band'
                };
                var lineTrace = {
                    x: xs,
                    y: ys,
                    name: ds.label || ('Series ' + (i + 1)),
                    type: 'scatter',
                    mode: ds.isFit ? 'lines' : plotMode,
                    line: {
                        color: color,
                        width: ds.borderWidth || 2,
                        dash: 'solid'
                    },
                    marker: {
                        size: ds.isFit ? 0 : mkSize,
                        color: color,
                        symbol: sym
                    },
                    legendgroup: 'series' + si,
                    _seriesIndex: si,
                    _seriesRole: 'main',
                    _isFit: !!ds.isFit
                };
                return [bandTrace, lineTrace];
            }

            var trace = {
                x: xs,
                y: ys,
                name: ds.label || ('Series ' + (i + 1)),
                type: 'scatter',
                mode: ds.isFit ? 'lines' : plotMode,
                line: {
                    color: color,
                    width: ds.borderWidth || 2,
                    dash: 'solid'
                },
                marker: {
                    size: ds.isFit ? 0 : mkSize,
                    color: color,
                    symbol: sym
                },
                legendgroup: 'series' + si,
                _seriesIndex: si,
                _seriesRole: 'main',
                _isFit: !!ds.isFit
            };
            if (hasErr && !ds.isFit) trace.error_y = { type: 'data', array: errY, color: color, thickness: 1 };
            return [trace];
        }

        function pushDatasetTraces(ds, i, xName, yName) {
            var arr = tracesFromDataset(ds, i);
            arr.forEach(function (tr) {
                if (xName) tr.xaxis = xName;
                if (yName) tr.yaxis = yName;
                traces.push(tr);
            });
        }

        if (useMultigraph && nPanels > 1) {
            for (var p = 0; p < nPanels; p++) {
                var seriesList = panelAssign[p];
                if (!seriesList || !seriesList.length) continue;
                var xName = p === 0 ? 'x' : 'x' + (p + 1);
                var yName = p === 0 ? 'y' : 'y' + (p + 1);
                for (var pi = 0; pi < seriesList.length; pi++) {
                    var s = seriesList[pi];
                    var ds = datasets[s];
                    if (!ds) continue;
                    pushDatasetTraces(ds, s, xName, yName);
                }
            }
        } else {
            datasets.forEach(function (ds, i) {
                pushDatasetTraces(ds, i, null, null);
            });
        }

        var layout;
        if (useMultigraph && nPanels > 1) {
            var gap = 0.04;
            var xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity;
            traces.forEach(function (t) {
                var x = t.x, y = t.y;
                if (x && x.length) for (var i = 0; i < x.length; i++) { if (x[i] != null && !isNaN(x[i])) { if (x[i] < xMin) xMin = x[i]; if (x[i] > xMax) xMax = x[i]; } }
                if (y && y.length) for (var j = 0; j < y.length; j++) { if (y[j] != null && !isNaN(y[j])) { if (y[j] < yMin) yMin = y[j]; if (y[j] > yMax) yMax = y[j]; } }
            });
            var sharedXRange = (xMin <= xMax && isFinite(xMin) && isFinite(xMax)) ? [xMin, xMax] : undefined;
            var sharedYRange = (yMin <= yMax && isFinite(yMin) && isFinite(yMax)) ? [yMin, yMax] : undefined;
            if (scaleOpts.x.min != null && scaleOpts.x.max != null) sharedXRange = [scaleOpts.x.min, scaleOpts.x.max];
            if (scaleOpts.y.min != null && scaleOpts.y.max != null) sharedYRange = [scaleOpts.y.min, scaleOpts.y.max];
            var xLinMg = scaleOpts.x.type === 'logarithmic' ? 'log' : 'linear';
            var yLinMg = scaleOpts.y.type === 'logarithmic' ? 'log' : 'linear';
            layout = {
                showlegend: legendShow ? legendShow.checked : true,
                legend: { x: 1, xanchor: 'right', y: 1, font: { size: 12, family: ROOT_STYLE.fontFamily } },
                title: (chartTitle && chartTitle.value) ? { text: formatPlotlyLatex(chartTitle.value) } : undefined,
                paper_bgcolor: ROOT_STYLE.canvasBg,
                plot_bgcolor: ROOT_STYLE.canvasBg,
                margin: { t: 50, b: 40, l: 50, r: 40 },
                autosize: true
            };
            for (var p = 0; p < nPanels; p++) {
                var col = p % pl.cols;
                var row = Math.floor(p / pl.cols);
                var xLeft = col / pl.cols + gap / 2;
                var xRight = (col + 1) / pl.cols - gap / 2;
                var yTop = 1 - row / pl.rows - gap / 2;
                var yBottom = 1 - (row + 1) / pl.rows + gap / 2;
                var xKey = p === 0 ? 'xaxis' : 'xaxis' + (p + 1);
                var yKey = p === 0 ? 'yaxis' : 'yaxis' + (p + 1);
                var xAnchor = p === 0 ? 'y' : 'y' + (p + 1);
                var yAnchor = p === 0 ? 'x' : 'x' + (p + 1);
                layout[xKey] = Object.assign({}, getPlotlyAxisFrameAndTickOpts(true, xLinMg, showGridX, false), {
                    domain: [xLeft, xRight],
                    anchor: xAnchor,
                    title: { text: col === 0 ? xTitle : '', font: { size: axisSize, family: ROOT_STYLE.fontFamily } },
                    type: xLinMg,
                    range: sharedXRange,
                    showgrid: showGridX,
                    gridcolor: ROOT_STYLE.gridColor,
                    tickfont: { size: tickSz, family: ROOT_STYLE.fontFamily, color: ROOT_STYLE.tickColor }
                });
                layout[yKey] = Object.assign({}, getPlotlyAxisFrameAndTickOpts(false, yLinMg, showGridY, !scaleOpts.y.beginAtZero ? false : true), {
                    domain: [yBottom, yTop],
                    anchor: yAnchor,
                    title: { text: row === 0 ? yTitle : '', font: { size: axisSize, family: ROOT_STYLE.fontFamily } },
                    type: yLinMg,
                    range: sharedYRange,
                    showgrid: showGridY,
                    gridcolor: ROOT_STYLE.gridColor,
                    tickfont: { size: tickSz, family: ROOT_STYLE.fontFamily, color: ROOT_STYLE.tickColor }
                });
            }
        } else {
        var showRatio = !useMultigraph && ratioPanelActive && ratioNumeratorSelect && ratioDenominatorSelect &&
            yIndices.length >= 2;
        var ratioTraces = [];
        if (showRatio) {
            var numSeries = parseInt(ratioNumeratorSelect.value, 10);
            var denSeries = parseInt(ratioDenominatorSelect.value, 10);
            if (!isNaN(numSeries) && !isNaN(denSeries) && numSeries !== denSeries &&
                numSeries >= 0 && numSeries < yIndices.length && denSeries >= 0 && denSeries < yIndices.length) {
                var numIdx = yIndices[numSeries];
                var denIdx = yIndices[denSeries];
                var numErr = getSeriesYErrors(numSeries) || [];
                var denErr = getSeriesYErrors(denSeries) || [];
                var points = [];
                for (var ri = 0; ri < rows.length; ri++) {
                    var r = rows[ri];
                    var xVal = r[xIdx];
                    var yNum = r[numIdx];
                    var yDen = r[denIdx];
                    if (xVal == null || yNum == null || yDen == null) continue;
                    if (yDen === 0) continue;
                    var ratio = yNum / yDen;
                    var eNum = (numErr.length > ri && numErr[ri] != null && !isNaN(numErr[ri])) ? Math.abs(Number(numErr[ri])) : null;
                    var eDen = (denErr.length > ri && denErr[ri] != null && !isNaN(denErr[ri])) ? Math.abs(Number(denErr[ri])) : null;
                    var yMin = null, yMax = null;
                    if (eNum != null || eDen != null) {
                        var relNum = (eNum != null && yNum !== 0) ? eNum / Math.abs(yNum) : 0;
                        var relDen = (eDen != null && yDen !== 0) ? eDen / Math.abs(yDen) : 0;
                        var eRatio = Math.abs(ratio) * Math.sqrt(relNum * relNum + relDen * relDen);
                        yMin = ratio - eRatio;
                        yMax = ratio + eRatio;
                    }
                    points.push(yMin != null && yMax != null ? { x: xVal, y: ratio, yMin: yMin, yMax: yMax } : { x: xVal, y: ratio });
                }
                if (points.length) {
                    var ratioX = points.map(function (p) { return p.x; });
                    var ratioY = points.map(function (p) { return p.y; });
                    var ratioErrY = points.map(function (p) { return (p.yMin != null && p.yMax != null) ? (Number(p.yMax) - Number(p.yMin)) / 2 : 0; });
                    var hasRatioErr = ratioErrY.some(function (e) { return e > 0; });
                    var ratioTrace = {
                        x: ratioX, y: ratioY,
                        name: (headers[numIdx] || 'num') + ' / ' + (headers[denIdx] || 'den'),
                        type: 'scatter', mode: 'lines',
                        line: { color: '#000000', width: 2 },
                        marker: { size: 0, color: '#000000' },
                        yaxis: 'y2'
                    };
                    if (hasRatioErr) ratioTrace.error_y = { type: 'data', array: ratioErrY, color: '#000000' };
                    ratioTraces.push(ratioTrace);
                    ratioTraces.push({
                        x: ratioX,
                        y: points.map(function () { return 1; }),
                        name: 'unity',
                        type: 'scatter', mode: 'lines',
                        line: { color: '#666666', width: 1, dash: 'dash' },
                        marker: { size: 0 },
                        yaxis: 'y2'
                    });
                }
            }
        }
        if (ratioTraces.length) {
            traces.forEach(function (t) { t.yaxis = 'y'; });
            traces.push.apply(traces, ratioTraces);
        }
        var xRange = (scaleOpts.x.min != null && scaleOpts.x.max != null) ? [scaleOpts.x.min, scaleOpts.x.max] : undefined;
        var yRange = (scaleOpts.y.min != null && scaleOpts.y.max != null) ? [scaleOpts.y.min, scaleOpts.y.max] : undefined;
        var hasRatio = ratioTraces.length > 0;
        var ratioHeight = hasRatio ? 0.35 : 0;
        var mainBottom = hasRatio ? ratioHeight + 0.02 : 0;
        var mainTop = 1;
        var xLin = scaleOpts.x.type === 'logarithmic' ? 'log' : 'linear';
        var yLin = scaleOpts.y.type === 'logarithmic' ? 'log' : 'linear';
        var xaxisOpts = Object.assign({}, getPlotlyAxisFrameAndTickOpts(true, xLin, showGridX, false), {
            title: { text: xTitle, font: { size: axisSize, family: ROOT_STYLE.fontFamily } },
            type: xLin,
            range: xRange,
            showgrid: showGridX,
            gridcolor: ROOT_STYLE.gridColor,
            tickfont: { size: tickSz, family: ROOT_STYLE.fontFamily, color: ROOT_STYLE.tickColor }
        });
        if (hasRatio) {
            xaxisOpts.domain = [0, 1];
            xaxisOpts.anchor = 'y2';
            xaxisOpts.side = 'bottom';
        }
        var yaxisOpts = Object.assign({}, getPlotlyAxisFrameAndTickOpts(false, yLin, showGridY, !scaleOpts.y.beginAtZero ? false : true), {
            title: { text: yTitle, font: { size: axisSize, family: ROOT_STYLE.fontFamily } },
            type: yLin,
            range: yRange,
            showgrid: showGridY,
            gridcolor: ROOT_STYLE.gridColor,
            tickfont: { size: tickSz, family: ROOT_STYLE.fontFamily, color: ROOT_STYLE.tickColor }
        });
        if (hasRatio) {
            yaxisOpts.domain = [mainBottom, mainTop];
            yaxisOpts.anchor = 'x';
        }
        layout = {
            xaxis: xaxisOpts,
            yaxis: yaxisOpts,
            showlegend: legendShow ? legendShow.checked : true,
            legend: {
                x: 1, xanchor: 'right', y: 1, yanchor: 'top',
                font: { size: 12, family: ROOT_STYLE.fontFamily, color: ROOT_STYLE.labelColor }
            },
            title: (chartTitle && chartTitle.value) ? { text: formatPlotlyLatex(chartTitle.value), font: { size: 14, family: ROOT_STYLE.fontFamily } } : undefined,
            paper_bgcolor: ROOT_STYLE.canvasBg,
            plot_bgcolor: ROOT_STYLE.canvasBg,
            margin: { t: 60, b: 60, l: 70, r: 40 },
            autosize: true
        };
        if (hasRatio) {
            var ratioTitleRaw = (function () {
                var el = document.getElementById('ratioAxisTitle');
                return (el && el.value.trim()) ? el.value.trim() : 'Ratio';
            })();
            var ratioYaxis2 = Object.assign({}, getPlotlyAxisFrameAndTickOpts(false, 'linear', showGridY, true), {
                domain: [0, ratioHeight],
                anchor: 'x',
                title: { text: formatPlotlyLatex(ratioTitleRaw), font: { size: axisSize, family: ROOT_STYLE.fontFamily } },
                type: 'linear',
                showgrid: showGridY,
                gridcolor: ROOT_STYLE.gridColor,
                tickfont: { size: tickSz, family: ROOT_STYLE.fontFamily, color: ROOT_STYLE.tickColor }
            });
            var rminEl = document.getElementById('ratioAxisYMin');
            var rmaxEl = document.getElementById('ratioAxisYMax');
            var rMinVal = rminEl && rminEl.value !== '' ? parseFloat(rminEl.value) : null;
            var rMaxVal = rmaxEl && rmaxEl.value !== '' ? parseFloat(rmaxEl.value) : null;
            if (rMinVal != null && !isNaN(rMinVal) && rMaxVal != null && !isNaN(rMaxVal)) {
                ratioYaxis2.range = [rMinVal, rMaxVal];
            }
            layout.yaxis2 = ratioYaxis2;
        }
        if (doStack) layout.barmode = 'stack';
        }

        var canvasSize = getCanvasSize();
        if (canvasSize.width != null && canvasSize.height != null) {
            layout.width = canvasSize.width;
            layout.height = canvasSize.height;
        }
        lastPlotState = { traces: traces, layout: layout, chartType: type, datasets: datasets };
        currentChart = true;
        if (!useMultigraph && datasets.length && datasets.every(function (ds) { return ds.isFit; })) {
            var psl = document.getElementById('plotShowLine');
            var psm = document.getElementById('plotShowMarkers');
            if (psl) psl.checked = true;
            if (psm) psm.checked = false;
        }
        if (typeof Plotly !== 'undefined' && plotDiv) {
            var useAutosize = canvasSize.width == null || canvasSize.height == null;
            lastMinorDtickSyncSig = '';
            chainPlotlyAfterDraw(Plotly.newPlot(plotDiv, traces, layout, { responsive: useAutosize, autosize: useAutosize, displayModeBar: true, displaylogo: false }));
        }
        if (!useMultigraph) destroyRatioChart();
        syncRightPanelFromChart();
        if (storedSeriesColors && lastPlotState.traces.length) {
            storedSeriesColors.forEach(function (hex, i) {
                if (hex) applySeriesColor(i, hex);
            });
            if (typeof Plotly !== 'undefined' && plotDiv) chainPlotlyAfterDraw(Plotly.react(plotDiv, lastPlotState.traces, lastPlotState.layout));
            fillSeriesColors();
            storedSeriesColors = null;
        }
        clearMessage();
    }

    // ========== SERIES & LEGEND UI ==========
    function getChartType() {
        if (!currentChart || !lastPlotState.chartType) return null;
        return lastPlotState.chartType;
    }

    function updatePlotlyChart() {
        if (!currentChart || typeof Plotly === 'undefined' || !plotDiv || !lastPlotState.traces || !lastPlotState.traces.length) return;
        var canvasSize = getCanvasSize();
        var layout = lastPlotState.layout;
        if (canvasSize.width != null && canvasSize.height != null) {
            layout.width = canvasSize.width;
            layout.height = canvasSize.height;
        } else {
            delete layout.width;
            delete layout.height;
        }
        applyCanvasSizeToContainer();
        var useAutosize = canvasSize.width == null || canvasSize.height == null;
        chainPlotlyAfterDraw(Plotly.react(plotDiv, lastPlotState.traces, layout, { responsive: useAutosize, autosize: useAutosize }));
    }

    function traceToLineStyleKey(trace) {
        return plotlyDashToLineStyleKey(trace.line && trace.line.dash);
    }

    function updateChartTypeBlocks() {
        if (!currentChart || !lastPlotState.traces || !lastPlotState.traces.length) return;
        var type = getChartType();
        if (xyDisplayBlock) xyDisplayBlock.style.display = (type === 'line' || type === 'scatter') ? 'block' : 'none';
        var t0 = null;
        for (var ti = 0; ti < lastPlotState.traces.length; ti++) {
            if (lastPlotState.traces[ti]._seriesRole !== 'band' && lastPlotState.traces[ti].yaxis !== 'y2') {
                t0 = lastPlotState.traces[ti];
                break;
            }
        }
        if ((type === 'line' || type === 'scatter') && plotShowLine && plotShowMarkers && lineWidthScatter && t0) {
            plotShowLine.checked = !!(t0.mode && t0.mode.indexOf('lines') >= 0);
            plotShowMarkers.checked = !!(t0.mode && t0.mode.indexOf('markers') >= 0);
            var w = t0.line && t0.line.width;
            lineWidthScatter.value = (typeof w === 'number' && w >= 1 && w <= 8) ? String(w) : '2';
        }
        fillMarkerOptions();
    }

    function syncRightPanelFromChart() {
        if (!currentChart) return;
        var layout = lastPlotState.layout || {};
        if (layout.xaxis && layout.xaxis.title && layout.xaxis.title.text) xLabelEl.value = layout.xaxis.title.text;
        if (layout.yaxis && layout.yaxis.title && layout.yaxis.title.text) yLabelEl.value = layout.yaxis.title.text;
        var rt = document.getElementById('ratioAxisTitle');
        var rmin = document.getElementById('ratioAxisYMin');
        var rmax = document.getElementById('ratioAxisYMax');
        if (layout.yaxis2) {
            if (rt && layout.yaxis2.title && layout.yaxis2.title.text) rt.value = String(layout.yaxis2.title.text).replace(/\u00a0/g, ' ');
            if (layout.yaxis2.range && Array.isArray(layout.yaxis2.range) && layout.yaxis2.range.length >= 2) {
                if (rmin && layout.yaxis2.range[0] != null) rmin.value = String(layout.yaxis2.range[0]);
                if (rmax && layout.yaxis2.range[1] != null) rmax.value = String(layout.yaxis2.range[1]);
            }
        }
        fillSeriesColors();
        updateChartTypeBlocks();
        fillLegendLabels();
    }

    function fillLegendLabels() {
        var container = document.getElementById('legendLabels');
        if (!currentChart || !container || !lastPlotState.traces) return;
        container.innerHTML = '';
        var rowNum = 0;
        lastPlotState.traces.forEach(function (trace, traceIdx) {
            if (trace._seriesRole === 'band') return;
            if (trace.yaxis === 'y2' || trace.name === 'unity') return;
            var sid = trace._seriesIndex != null ? trace._seriesIndex : traceIdx;
            var row = document.createElement('div');
            row.className = 'legend-label-row';
            var input = document.createElement('input');
            input.type = 'text';
            input.value = trace.name || '';
            input.dataset.seriesIndex = String(sid);
            rowNum++;
            input.placeholder = 'Series ' + rowNum;
            input.title = 'Legend text for this series';
            row.appendChild(input);
            container.appendChild(row);
            input.addEventListener('change', function () {
                var sid2 = parseInt(this.dataset.seriesIndex, 10);
                var nm = this.value.trim();
                if (!currentChart || !lastPlotState.traces) return;
                lastPlotState.traces.forEach(function (t, ti) {
                    if (t._seriesRole === 'band') return;
                    var match = (t._seriesIndex != null) ? (t._seriesIndex === sid2) : (ti === sid2);
                    if (!match) return;
                    t.name = nm || t.name;
                });
                updatePlotlyChart();
            });
        });
    }

    function fillSeriesColors() {
        if (!currentChart || !seriesColors || !lastPlotState.traces) return;
        seriesColors.innerHTML = '';
        var rowNum = 0;
        lastPlotState.traces.forEach(function (trace, traceIdx) {
            if (trace._seriesRole === 'band') return;
            if (trace.yaxis === 'y2' || trace.name === 'unity') return;
            var sid = trace._seriesIndex != null ? trace._seriesIndex : traceIdx;
            var color = (trace.line && trace.line.color) || (trace.marker && trace.marker.color) || (trace.marker && trace.marker) || DEFAULT_COLORS[sid % DEFAULT_COLORS.length];
            var hex = typeof color === 'string' && color.startsWith('#') ? color : '#06328a';
            var lineKey = traceToLineStyleKey(trace);
            var lineLabels = { solid: 'Solid', dashed: 'Dashed', dotted: 'Dotted', longdash: 'Long dash', dashdot: 'Dash–dot', longdashdot: 'Long dash–dot' };
            var lineOpts = ['solid', 'dashed', 'dotted', 'longdash', 'dashdot', 'longdashdot'].map(function (k) {
                return '<option value="' + k + '"' + (lineKey === k ? ' selected' : '') + '>' + (lineLabels[k] || k) + '</option>';
            }).join('');
            rowNum++;
            var label = trace.name || ('Series ' + rowNum);
            var row = document.createElement('div');
            row.className = 'series-color-row';
            row.innerHTML = '<label title="' + escapeHtml(label) + '">' + escapeHtml(label) + '</label>' +
                '<input type="color" value="' + hex + '" data-series-index="' + sid + '" title="Line/series color">' +
                '<input type="text" class="color-hex-input" data-series-index="' + sid + '" value="' + hex + '" maxlength="7" spellcheck="false" title="Hex color #RRGGBB" aria-label="Hex color">' +
                '<select class="series-line-style" data-series-index="' + sid + '" title="Line style">' + lineOpts + '</select>';
            seriesColors.appendChild(row);
            row.querySelector('input[type="color"]').addEventListener('input', function () {
                var sidx = parseInt(this.dataset.seriesIndex, 10);
                var v = this.value;
                applySeriesColor(sidx, v);
                var hx = row.querySelector('.color-hex-input');
                if (hx) hx.value = v;
                updatePlotlyChart();
            });
            var hexIn = row.querySelector('.color-hex-input');
            if (hexIn) {
                hexIn.addEventListener('change', function () {
                    var sidx = parseInt(this.dataset.seriesIndex, 10);
                    var raw = (this.value || '').trim();
                    if (!/^#[0-9A-Fa-f]{6}$/.test(raw)) return;
                    applySeriesColor(sidx, raw);
                    var cp = row.querySelector('input[type="color"]');
                    if (cp) cp.value = raw;
                    this.value = raw;
                    updatePlotlyChart();
                });
            }
            row.querySelector('.series-line-style').addEventListener('change', function () {
                var sidx = parseInt(this.dataset.seriesIndex, 10);
                var dash = LINE_STYLE_MAP[this.value] || 'solid';
                lastPlotState.traces.forEach(function (t, ti) {
                    if (!t.line || t._seriesRole === 'band') return;
                    var match = (t._seriesIndex != null) ? (t._seriesIndex === sidx) : (ti === sidx);
                    if (!match) return;
                    t.line.dash = dash;
                });
                updatePlotlyChart();
            });
        });
    }

    var MARKER_SIZES = [0, 2, 3, 4, 5, 6, 8];

    function fillMarkerOptions() {
        if (!currentChart || !seriesMarkers || !markerBlock || !lastPlotState.traces) return;
        var chartType = getChartType();
        if (chartType === 'bar') {
            markerBlock.style.display = 'none';
            return;
        }
        if (plotShowMarkers && !plotShowMarkers.checked) {
            markerBlock.style.display = 'none';
            return;
        }
        markerBlock.style.display = 'block';
        seriesMarkers.innerHTML = '';
        function mainTraceForSeries(sid) {
            for (var j = 0; j < lastPlotState.traces.length; j++) {
                var t = lastPlotState.traces[j];
                if (t._seriesRole === 'band') continue;
                if (t._seriesIndex != null) {
                    if (t._seriesIndex === sid) return t;
                }
            }
            return null;
        }
        lastPlotState.traces.forEach(function (trace, traceIdx) {
            if (trace._seriesRole === 'band') return;
            var sid = trace._seriesIndex != null ? trace._seriesIndex : traceIdx;
            var mk = trace.marker || {};
            var ptStyle = (mk.size === 0) ? 'none' : (mk.symbol || 'circle');
            var ptRadius = typeof mk.size === 'number' ? mk.size : 8;
            var ptColor = mk.color || (trace.line && trace.line.color) || DEFAULT_COLORS[sid % DEFAULT_COLORS.length];
            var hex = typeof ptColor === 'string' && ptColor.startsWith('#') ? ptColor : '#06328a';
            var label = trace.name || ('Series ' + (sid + 1));
            var markerOpts = MARKER_OPTIONS.map(function (o) {
                return '<option value="' + o.value + '"' + (ptStyle === o.value ? ' selected' : '') + '>' + o.label + '</option>';
            }).join('');
            var sizeOpts = MARKER_SIZES.map(function (s) {
                return '<option value="' + s + '"' + (ptRadius === s ? ' selected' : '') + '>' + (s === 0 ? 'None' : String(s)) + '</option>';
            }).join('');
            var row = document.createElement('div');
            row.className = 'marker-row';
            row.innerHTML = '<label title="' + escapeHtml(label) + '">' + escapeHtml(label) + '</label>' +
                '<select class="marker-style" data-series-index="' + sid + '" title="Marker style">' + markerOpts + '</select>' +
                '<select class="marker-size" data-series-index="' + sid + '" title="Marker size">' + sizeOpts + '</select>' +
                '<input type="color" value="' + hex + '" data-series-index="' + sid + '" title="Marker color">' +
                '<input type="text" class="color-hex-input marker-hex" data-series-index="' + sid + '" value="' + hex + '" maxlength="7" spellcheck="false" title="Hex #RRGGBB">';
            seriesMarkers.appendChild(row);
            row.querySelector('.marker-style').addEventListener('change', function () {
                var sidx = parseInt(this.dataset.seriesIndex, 10);
                var t = mainTraceForSeries(sidx);
                if (!t) return;
                var v = this.value;
                if (!t.marker) t.marker = {};
                if (v === 'none') {
                    t.marker.size = 0;
                    t.mode = (t.mode && t.mode.indexOf('lines') >= 0) ? 'lines' : 'markers';
                } else {
                    t.marker.symbol = v;
                    t.marker.size = t.marker.size || 8;
                    t.mode = (t.mode && t.mode.indexOf('lines') >= 0) ? 'lines+markers' : 'markers';
                }
                updatePlotlyChart();
            });
            row.querySelector('.marker-size').addEventListener('change', function () {
                var sidx = parseInt(this.dataset.seriesIndex, 10);
                var t = mainTraceForSeries(sidx);
                if (!t) return;
                var v = parseInt(this.value, 10);
                if (!t.marker) t.marker = {};
                t.marker.size = v;
                if (v > 0 && !t.marker.symbol) t.marker.symbol = 'circle';
                updatePlotlyChart();
            });
            row.querySelector('input[type="color"]').addEventListener('input', function () {
                var sidx = parseInt(this.dataset.seriesIndex, 10);
                var t = mainTraceForSeries(sidx);
                if (t) {
                    if (!t.marker) t.marker = {};
                    t.marker.color = this.value;
                    syncMarkerAndErrorColor(t, this.value);
                    var hx = row.querySelector('.marker-hex');
                    if (hx) hx.value = this.value;
                    updatePlotlyChart();
                }
            });
            var mhex = row.querySelector('.marker-hex');
            if (mhex) {
                mhex.addEventListener('change', function () {
                    var sidx = parseInt(this.dataset.seriesIndex, 10);
                    var raw = (this.value || '').trim();
                    if (!/^#[0-9A-Fa-f]{6}$/.test(raw)) return;
                    var t = mainTraceForSeries(sidx);
                    if (t) {
                        if (!t.marker) t.marker = {};
                        t.marker.color = raw;
                        syncMarkerAndErrorColor(t, raw);
                        var cp = row.querySelector('input[type="color"]');
                        if (cp) cp.value = raw;
                        this.value = raw;
                        updatePlotlyChart();
                    }
                });
            }
        });
    }

    // ========== APPLY HANDLERS ==========
    function applyRange() {
        if (!currentChart || !lastPlotState.layout) return;
        var xMin = (xMinEl || document.getElementById('xMin'));
        var xMax = (xMaxEl || document.getElementById('xMax'));
        var yMin = (yMinEl || document.getElementById('yMin'));
        var yMax = (yMaxEl || document.getElementById('yMax'));
        if (!xMin || !xMax || !yMin || !yMax) return;
        var l = lastPlotState.layout;
        var xMinVal = xMin.value !== '' ? parseFloat(xMin.value) : null;
        var xMaxVal = xMax.value !== '' ? parseFloat(xMax.value) : null;
        var yMinVal = yMin.value !== '' ? parseFloat(yMin.value) : null;
        var yMaxVal = yMax.value !== '' ? parseFloat(yMax.value) : null;
        if (l.xaxis) {
            if (xMinVal != null && !isNaN(xMinVal) && xMaxVal != null && !isNaN(xMaxVal)) l.xaxis.range = [xMinVal, xMaxVal];
            else if (xMinVal != null && !isNaN(xMinVal)) l.xaxis.range = [xMinVal, l.xaxis.range && l.xaxis.range[1] != null ? l.xaxis.range[1] : undefined];
            else if (xMaxVal != null && !isNaN(xMaxVal)) l.xaxis.range = [l.xaxis.range && l.xaxis.range[0] != null ? l.xaxis.range[0] : undefined, xMaxVal];
            else delete l.xaxis.range;
        }
        if (l.yaxis) {
            if (yMinVal != null && !isNaN(yMinVal) && yMaxVal != null && !isNaN(yMaxVal)) l.yaxis.range = [yMinVal, yMaxVal];
            else if (yMinVal != null && !isNaN(yMinVal)) l.yaxis.range = [yMinVal, l.yaxis.range && l.yaxis.range[1] != null ? l.yaxis.range[1] : undefined];
            else if (yMaxVal != null && !isNaN(yMaxVal)) l.yaxis.range = [l.yaxis.range && l.yaxis.range[0] != null ? l.yaxis.range[0] : undefined, yMaxVal];
            else delete l.yaxis.range;
        }
        if (l.yaxis2) {
            var rminEl = document.getElementById('ratioAxisYMin');
            var rmaxEl = document.getElementById('ratioAxisYMax');
            var rtEl = document.getElementById('ratioAxisTitle');
            if (rtEl && rtEl.value.trim()) {
                l.yaxis2.title = l.yaxis2.title || {};
                l.yaxis2.title.text = formatPlotlyLatex(rtEl.value.trim());
            }
            var rMinV = rminEl && rminEl.value !== '' ? parseFloat(rminEl.value) : null;
            var rMaxV = rmaxEl && rmaxEl.value !== '' ? parseFloat(rmaxEl.value) : null;
            if (rMinV != null && !isNaN(rMinV) && rMaxV != null && !isNaN(rMaxV)) l.yaxis2.range = [rMinV, rMaxV];
            else delete l.yaxis2.range;
        }
        updatePlotlyChart();
    }

    function applyLabels() {
        if (!currentChart || !lastPlotState.layout) return;
        var xL = (xLabelEl || document.getElementById('xLabel'));
        var yL = (yLabelEl || document.getElementById('yLabel'));
        if (!xL || !yL) return;
        var l = lastPlotState.layout;
        if (l.xaxis) { l.xaxis.title = l.xaxis.title || {}; l.xaxis.title.text = formatPlotlyLatex(xL.value || 'X'); }
        if (l.yaxis) { l.yaxis.title = l.yaxis.title || {}; l.yaxis.title.text = formatPlotlyLatex(yL.value || 'Y'); }
        updatePlotlyChart();
    }

    function applyGridAndFont() {
        if (!currentChart || !lastPlotState.layout) return;
        try {
            var gX = document.getElementById('gridX');
            var gY = document.getElementById('gridY');
            var aSize = document.getElementById('axisLabelSize');
            var tSize = document.getElementById('tickSize');
            var axisSize = aSize && aSize.value ? parseInt(aSize.value, 10) : 12;
            var tickSz = tSize && tSize.value ? parseInt(tSize.value, 10) : 11;
            var showGridX = gX ? gX.checked : false;
            var showGridY = gY ? gY.checked : false;
            var l = lastPlotState.layout;
            applyAxisFrameAndTicksToLayout();
            Object.keys(l).forEach(function (key) {
                if (!(key === 'xaxis' || /^xaxis\d+$/.test(key) || key === 'yaxis' || /^yaxis\d+$/.test(key))) return;
                var ax = l[key];
                if (!ax || typeof ax !== 'object') return;
                var isX = key.indexOf('xaxis') === 0;
                ax.showgrid = isX ? showGridX : showGridY;
                ax.gridcolor = ROOT_STYLE.gridColor;
                if (ax.minor) ax.minor.showgrid = isX ? showGridX : showGridY;
                ax.tickfont = ax.tickfont || {};
                ax.tickfont.size = tickSz;
                ax.title = ax.title || {};
                ax.title.font = ax.title.font || {};
                ax.title.font.size = axisSize;
            });
            updatePlotlyChart();
        } catch (e) { console.warn('applyGridAndFont', e); }
    }

    function applyLogScale() {
        if (!currentChart || !lastPlotState.layout) return;
        var xLog = document.getElementById('xLogScale');
        var yLog = document.getElementById('yLogScale');
        if (!xLog || !yLog) return;
        var l = lastPlotState.layout;
        if (l.xaxis) l.xaxis.type = xLog.checked ? 'log' : 'linear';
        if (l.yaxis) { l.yaxis.type = yLog.checked ? 'log' : 'linear'; l.yaxis.zeroline = !yLog.checked; }
        applyAxisFrameAndTicksToLayout();
        updatePlotlyChart();
    }

    function applyLegend() {
        if (!currentChart || !lastPlotState.layout) return;
        var show = document.getElementById('legendShow');
        var pos = document.getElementById('legendPosition');
        lastPlotState.layout.showlegend = show ? show.checked : true;
        if (lastPlotState.layout.legend) lastPlotState.layout.legend.x = pos && pos.value === 'left' ? 0 : 1;
        updatePlotlyChart();
    }

    function applyText() {
        if (!currentChart || !lastPlotState.layout) return;
        var titleEl = chartTitle || document.getElementById('chartTitle');
        var title = titleEl ? titleEl.value.trim() : '';
        lastPlotState.layout.title = title ? { text: formatPlotlyLatex(title), font: { size: 14, family: ROOT_STYLE.fontFamily } } : undefined;
        updatePlotlyChart();
    }

    // ========== EXPORT ==========
    function exportImage(mime, ext) {
        if (!currentChart || typeof Plotly === 'undefined' || !plotDiv) return;
        var presetKey = exportPresetSelect && exportPresetSelect.value ? exportPresetSelect.value : 'screen';
        var targetWidth = EXPORT_PRESETS[presetKey] || 0;
        var fmt = ext === 'svg' ? 'svg' : (mime === 'image/jpeg' ? 'jpeg' : 'png');
        var opts = { format: fmt, filename: 'plot' };
        if (targetWidth && targetWidth > 0) opts.width = targetWidth;
        if (fmt === 'jpeg') opts.setBackground = true;
        function exportFail(err) {
            var msg = (err && err.message) ? err.message : String(err);
            showMessage('Export failed: ' + msg, true);
        }
        if (typeof Plotly.downloadImage === 'function') {
            Plotly.downloadImage(plotDiv, opts).catch(exportFail);
            return;
        }
        Plotly.toImage(plotDiv, opts).then(function (url) {
            var link = document.createElement('a');
            link.download = 'plot.' + ext;
            link.href = url;
            link.rel = 'noopener';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }).catch(exportFail);
    }

    function exportPdfFn() {
        if (!currentChart || typeof Plotly === 'undefined' || !plotDiv) return;
        var JsPDF = (window.jspdf && window.jspdf.jsPDF) || (typeof window.jsPDF === 'function' ? window.jsPDF : null) ||
            (typeof jspdf !== 'undefined' && jspdf.jsPDF ? jspdf.jsPDF : null);
        if (!JsPDF) {
            showMessage('PDF export requires jsPDF. Load the script and try again.', true);
            return;
        }
        var presetKey = exportPresetSelect && exportPresetSelect.value ? exportPresetSelect.value : 'screen';
        var targetWidth = EXPORT_PRESETS[presetKey] || 1200;
        Plotly.toImage(plotDiv, { format: 'png', width: targetWidth }).then(function (url) {
            var doc = new JsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
            var w = doc.internal.pageSize.getWidth();
            var h = doc.internal.pageSize.getHeight();
            var img = new Image();
            img.onload = function () {
                var ratio = img.width / img.height;
                var imgW = w;
                var imgH = w / ratio;
                if (imgH > h) { imgH = h; imgW = h * ratio; }
                doc.addImage(url, 'PNG', (w - imgW) / 2, (h - imgH) / 2, imgW, imgH);
                doc.save('plot.pdf');
            };
            img.onerror = function () { showMessage('PDF export failed.', true); };
            img.src = url;
        }).catch(function (err) { showMessage('PDF export failed: ' + (err && err.message) || 'unknown', true); });
    }

    function escapePythonStr(s) {
        if (s == null) return '""';
        var t = String(s).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
        return "'" + t + "'";
    }

    /**
     * Matplotlib treats '$' as math mode. Plotly/ROOT labels often look like
     * "$#Delta$\\varphi$ (rad)$" which breaks mathtext. Strip Plotly '$', map ROOT
     * '#foo' to '\\foo', then use a single '$...$' mathtext block when needed.
     */
    function labelForMatplotlibExport(s) {
        if (s == null || s === '') return '';
        var t = String(s).trim();
        t = t.replace(/\$/g, '');
        var map = {
            '#Delta': '\\Delta', '#Gamma': '\\Gamma', '#Lambda': '\\Lambda',
            '#varphi': '\\varphi', '#phi': '\\phi', '#theta': '\\theta', '#sigma': '\\sigma',
            '#alpha': '\\alpha', '#beta': '\\beta', '#gamma': '\\gamma', '#delta': '\\delta',
            '#epsilon': '\\epsilon', '#mu': '\\mu', '#pi': '\\pi', '#rho': '\\rho',
            '#tau': '\\tau', '#omega': '\\omega', '#Omega': '\\Omega', '#infty': '\\infty'
        };
        Object.keys(map).forEach(function (k) {
            t = t.split(k).join(map[k]);
        });
        t = t.replace(/\s+/g, ' ').trim();
        if (/\\[a-zA-Z]+/.test(t)) {
            return '$' + t + '$';
        }
        return t;
    }

    function generatePythonScript() {
        if (!parsedData || !parsedData.rows || parsedData.rows.length === 0) {
            showMessage('Load data and plot first, then generate the script.', true);
            return null;
        }
        var xIdx = getSelectedXIndex();
        var yIndices = getSelectedYIndices();
        if (yIndices.length === 0) yIndices = [parsedData.headers.length > 1 ? 1 : 0];
        var headers = parsedData.headers;
        var rows = parsedData.rows;
        var chartType = chartTypeSelect ? chartTypeSelect.value : 'line';
        var xLabel = labelForMatplotlibExport((xLabelEl && xLabelEl.value) ? xLabelEl.value : (headers[xIdx] || 'X'));
        var yLabel = labelForMatplotlibExport((yLabelEl && yLabelEl.value) ? yLabelEl.value : 'Y');
        var title = labelForMatplotlibExport((chartTitle && chartTitle.value) ? chartTitle.value : '');
        var xMin = (xMinEl && xMinEl.value !== '') ? parseFloat(xMinEl.value) : null;
        var xMax = (xMaxEl && xMaxEl.value !== '') ? parseFloat(xMaxEl.value) : null;
        var yMin = (yMinEl && yMinEl.value !== '') ? parseFloat(yMinEl.value) : null;
        var yMax = (yMaxEl && yMaxEl.value !== '') ? parseFloat(yMaxEl.value) : null;
        var xLog = xLogScale && xLogScale.checked;
        var yLog = yLogScale && yLogScale.checked;
        var showLegend = legendShow ? legendShow.checked : true;
        var legendPos = (legendPosition && legendPosition.value) ? legendPosition.value : 'best';
        var colors = DEFAULT_COLORS.slice();
        var seriesLabels = yIndices.map(function (_, i) { return headers[yIndices[i]] || 'Series ' + (i + 1); });
        if (currentChart && lastPlotState.traces) {
            lastPlotState.traces.forEach(function (t, i) {
                if (t.name) seriesLabels[i] = t.name;
                var c = (t.line && t.line.color) || (t.marker && t.marker.color);
                if (c) colors[i] = c;
            });
        }
        var script = [
            '#!/usr/bin/env python3',
            '# Generated by Data Plotter — edit and run to reproduce the plot in matplotlib.',
            '# Requires: pip install matplotlib numpy',
            '',
            'import numpy as np',
            'import matplotlib.pyplot as plt',
            ''
        ];

        // For text data, load from the original data file instead of embedding the full array.
        if (!isRootData) {
            var dataFileName = lastDataFileName || 'data.txt';
            var delimChoice = delimiterSelect ? delimiterSelect.value : 'auto';
            var detectedSep = detectDelimiter(rawText || '');
            var sepChar = null;
            if (delimChoice === 'tab') sepChar = '\t';
            else if (delimChoice === 'comma') sepChar = ',';
            else if (delimChoice === 'space') sepChar = null;
            else {
                if (detectedSep === '\t') sepChar = '\t';
                else if (detectedSep === ',') sepChar = ',';
                else sepChar = null;
            }
            var textLines = (rawText || '').split(/\r?\n/).filter(function (line) { return line.trim(); });
            var hasHeaderRow = false;
            if (textLines.length) {
                var firstLine = textLines[0];
                var sepForSplit = sepChar != null ? sepChar : /\s+/;
                var cells = typeof sepForSplit === 'string'
                    ? firstLine.split(sepForSplit)
                    : firstLine.split(sepForSplit).filter(function (c) { return c.trim(); });
                var allNumeric = cells.length > 0 && cells.every(function (cell) {
                    var v = parseFloat(cell.trim());
                    return cell.trim() !== '' && !isNaN(v);
                });
                hasHeaderRow = !allNumeric;
            }
            var pyDelimExpr;
            if (sepChar === '\t') pyDelimExpr = "'\\t'";
            else if (sepChar === ',') pyDelimExpr = "','";
            else pyDelimExpr = "None";
            var skipHeader = hasHeaderRow ? 1 : 0;
            script.push('');
            script.push('# ----- Data loading from file (same file you uploaded) -----');
            script.push('DATA_FILE = ' + escapePythonStr(dataFileName));
            script.push('data = np.genfromtxt(' +
                'DATA_FILE, comments="#", delimiter=' + pyDelimExpr +
                ', skip_header=' + skipHeader + ', invalid_raise=False)');
            script.push('');
        } else {
            // ROOT-derived data: embed numeric copy as before.
            var dataLines = [];
            var i, rowStr;
            for (i = 0; i < rows.length; i++) {
                rowStr = rows[i].map(function (v) {
                    if (v == null || v === '') return 'np.nan';
                    if (typeof v === 'number' && !isNaN(v)) return String(v);
                    var n = parseFloat(v);
                    if (!isNaN(n)) return String(n);
                    return 'np.nan';
                }).join(', ');
                dataLines.push('    [' + rowStr + ']');
            }
            var dataStr = 'data = np.array([\n' + dataLines.join(',\n') + '\n])';
            script.push('');
            script.push('# ----- Data (embedded copy from the ROOT plot) -----');
            script.push(dataStr);
            script.push('');
        }
        var xCol = xIdx + 1;
        var yCols = yIndices.map(function (idx) { return idx + 1; });
        script.push('# Column indices: x = col ' + xIdx + ', y = cols ' + yIndices.join(', '));
        script.push('x = data[:, ' + xIdx + ']');
        script.push('');
        script.push('fig, ax = plt.subplots(figsize=(8, 5))');
        script.push('ax.tick_params(axis="both", which="major", labelsize=11)');
        script.push('ax.set_xlabel(' + escapePythonStr(xLabel) + ', fontsize=12)');
        script.push('ax.set_ylabel(' + escapePythonStr(yLabel) + ', fontsize=12)');
        if (xLog) script.push('ax.set_xscale("log")');
        if (yLog) script.push('ax.set_yscale("log")');
        if (xMin != null || xMax != null) script.push('ax.set_xlim(' + (xMin != null ? xMin : 'None') + ', ' + (xMax != null ? xMax : 'None') + ')');
        if (yMin != null || yMax != null) script.push('ax.set_ylim(' + (yMin != null ? yMin : 'None') + ', ' + (yMax != null ? yMax : 'None') + ')');
        if (title) script.push('ax.set_title(' + escapePythonStr(title) + ', fontsize=12)');
        script.push('');
        yIndices.forEach(function (yIdx, si) {
            var label = labelForMatplotlibExport(seriesLabels[si] || headers[yIdx] || 'y' + (si + 1));
            var color = colors[si] || DEFAULT_COLORS[si % DEFAULT_COLORS.length];
            var yerr = getSeriesYErrors(si);
            var yVals = 'data[:, ' + yIdx + ']';
            if (chartType === 'bar') {
                script.push('ax.bar(x, ' + yVals + ', label=' + escapePythonStr(label) + ', color=' + escapePythonStr(color) + ', alpha=0.7)');
            } else {
                var hasErr = yerr && yerr.length > 0;
                if (hasErr) {
                    var errArr = yerr.map(function (e) { return (e != null && !isNaN(e)) ? Number(e) : 0; });
                    script.push('yerr_' + si + ' = np.array(' + JSON.stringify(errArr) + ')');
                }
                if (chartType === 'scatter') {
                    if (hasErr) {
                        script.push('ax.errorbar(x, ' + yVals + ', yerr=yerr_' + si + ', fmt=\'o\', label=' + escapePythonStr(label) + ', color=' + escapePythonStr(color) + ', capsize=2, markersize=5)');
                    } else {
                        script.push('ax.scatter(x, ' + yVals + ', label=' + escapePythonStr(label) + ', color=' + escapePythonStr(color) + ', s=25)');
                    }
                } else {
                    if (hasErr) {
                        script.push('ax.errorbar(x, ' + yVals + ', yerr=yerr_' + si + ', label=' + escapePythonStr(label) + ', color=' + escapePythonStr(color) + ', capsize=2)');
                    } else {
                        script.push('ax.plot(x, ' + yVals + ', label=' + escapePythonStr(label) + ', color=' + escapePythonStr(color) + ')');
                    }
                }
            }
        });
        script.push('');
        if (showLegend) script.push('ax.legend(loc=\'' + (legendPos === 'top' ? 'upper right' : legendPos) + '\', fontsize=10)');
        script.push('plt.tight_layout()');
        script.push('# plt.savefig("plot.png", dpi=150)');
        script.push('plt.show()');
        script.push('');
        return script.join('\n');
    }

    function downloadPythonScript() {
        var code = generatePythonScript();
        if (!code) return;
        var blob = new Blob([code], { type: 'text/x-python' });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'plot_script.py';
        a.click();
        URL.revokeObjectURL(a.href);
    }

    // ========== RESET ==========
    function resetToUpload() {
        rawText = '';
        parsedData = null;
        if (rootFileUrl) {
            URL.revokeObjectURL(rootFileUrl);
            rootFileUrl = null;
        }
        rootSessions = [];
        rootKeyNames = [];
        isRootData = false;
        lastDataFileName = null;
        lastDataFileType = null;
        var rootOpt = document.getElementById('rootOptionsBlock');
        if (rootOpt) rootOpt.hidden = true;
        if (panelLeft) panelLeft.classList.remove('root-mode');
        if (leftPanelRoot) leftPanelRoot.hidden = true;
        if (rootTreeContainer) rootTreeContainer.innerHTML = '';
        lastRootTreeForFilter = null;
        if (rootTreeFilter) rootTreeFilter.value = '';
        if (currentChart) {
            if (typeof Plotly !== 'undefined' && plotDiv) Plotly.purge(plotDiv);
            currentChart = null;
        }
        lastPlotState = { traces: [], layout: {}, chartType: null };
        destroyRatioChart();
        if (previewTable) previewTable.innerHTML = '';
        if (previewTableContainer) previewTableContainer.hidden = true;
        fileInput.value = '';
        var app = document.querySelector('.app');
        var ws = document.getElementById('workspace');
        if (app) app.classList.remove('view-workspace');
        if (ws) ws.style.display = '';
        const chartContainer = plotDiv && plotDiv.closest('.workspace-chart');
        if (chartContainer) chartContainer.classList.remove('visible');
        if (workspacePlaceholder) workspacePlaceholder.classList.remove('hidden');
        clearMessage();
        ratioPanelActive = false;
        syncRatioToggleButton();
    }


export function initPlotter() {
    topSection = document.getElementById('topSection');
    workspace = document.getElementById('workspace');
    dropZone = document.getElementById('dropZone');
    fileInput = document.getElementById('fileInput');
    browseBtn = document.getElementById('browseBtn');
    uploadHint = document.getElementById('uploadHint');
    messageEl = document.getElementById('message');
    leftPanelTxtDat = document.getElementById('leftPanelTxtDat');
    leftPanelRoot = document.getElementById('leftPanelRoot');
    xColumnList = document.getElementById('xColumnList');
    yColumnList = document.getElementById('yColumnList');
    previewTable = document.getElementById('previewTable');
    previewTableContainer = document.getElementById('previewTableContainer');
    plotDiv = document.getElementById(PLOT_DIV_ID);
    workspacePlaceholder = document.getElementById('workspacePlaceholder');
    plotBtn = document.getElementById('plotBtn');
    addMoreFilesBtn = document.getElementById('addMoreFilesBtn');
    clearPlotCanvasBtn = document.getElementById('clearPlotCanvasBtn');
    clearAllBtn = document.getElementById('clearAllBtn');
    startOverBtn = document.getElementById('startOverBtn');
    delimiterSelect = document.getElementById('delimiter');
    chartTypeSelect = document.getElementById('chartType');
    xMinEl = document.getElementById('xMin');
    xMaxEl = document.getElementById('xMax');
    yMinEl = document.getElementById('yMin');
    yMaxEl = document.getElementById('yMax');
    applyRangeBtn = document.getElementById('applyRangeBtn');
    xLabelEl = document.getElementById('xLabel');
    yLabelEl = document.getElementById('yLabel');
    applyLabelsBtn = document.getElementById('applyLabelsBtn');
    xLogScale = document.getElementById('xLogScale');
    yLogScale = document.getElementById('yLogScale');
    seriesColors = document.getElementById('seriesColors');
    seriesMarkers = document.getElementById('seriesMarkers');
    markerBlock = document.getElementById('markerBlock');
    xyDisplayBlock = document.getElementById('xyDisplayBlock');
    plotShowLine = document.getElementById('plotShowLine');
    plotShowMarkers = document.getElementById('plotShowMarkers');
    lineWidthScatter = document.getElementById('lineWidthScatter');
    legendShow = document.getElementById('legendShow');
    legendPosition = document.getElementById('legendPosition');
    chartTitle = document.getElementById('chartTitle');
    chartSubtitle = document.getElementById('chartSubtitle');
    applyTextBtn = document.getElementById('applyTextBtn');
    exportPng = document.getElementById('exportPng');
    exportJpeg = document.getElementById('exportJpeg');
    exportPdf = document.getElementById('exportPdf');
    exportPresetSelect = document.getElementById('exportPreset');
    gridX = document.getElementById('gridX');
    gridY = document.getElementById('gridY');
    axisLabelSize = document.getElementById('axisLabelSize');
    tickSize = document.getElementById('tickSize');
    axisAlign = document.getElementById('axisAlign');
    applyGridFontBtn = document.getElementById('applyGridFontBtn');
    rootTreeContainer = document.getElementById('rootTreeContainer');
    rootTreeFilter = document.getElementById('rootTreeFilter');
    panelLeft = document.getElementById('panelLeft');
    toggleRatioBtn = document.getElementById('toggleRatioBtn');
    ratioNumeratorSelect = document.getElementById('ratioNumerator');
    ratioDenominatorSelect = document.getElementById('ratioDenominator');
    panelAssignmentContainer = document.getElementById('panelAssignmentContainer');
    plotContainer = document.getElementById('plotContainer');
    canvasWidthEl = document.getElementById('canvasWidth');
    canvasHeightEl = document.getElementById('canvasHeight');
    applyCanvasSizeBtn = document.getElementById('applyCanvasSizeBtn');
    if (leftPanelRoot) leftPanelRoot.hidden = true;

    // ========== INIT & EVENTS ==========
    if (!dropZone || !document.querySelector('.app')) return;

    if (fileInput) fileInput.accept = '.txt,.dat,.root,.json';
    if (uploadHint) uploadHint.textContent = 'Accepted: .txt, .dat, .root, .json — Multiple ROOT files allowed. Max size: 1 GB';

    var appendNextFilePick = false;

    function handleAppendFileList(files) {
        if (!files || files.length === 0) return;
        var roots = [];
        var i;
        for (i = 0; i < files.length; i++) {
            if (detectFileType(files[i]) === 'root') roots.push(files[i]);
        }
        if (roots.length > 0) {
            if (leftPanelRoot && !leftPanelRoot.hidden && rootSessions.length) {
                handleRootFiles(roots, true);
            } else {
                handleRootFiles(roots, false);
            }
            return;
        }
        if (files.length === 1) {
            handleFile(files[0]);
            return;
        }
        showMessage('Add .root files to append to the tree, or choose one text file at a time.', true);
    }

    function handleFileInputList(files) {
        if (!files || files.length === 0) return;
        if (appendNextFilePick) {
            appendNextFilePick = false;
            handleAppendFileList(files);
            return;
        }
        if (files.length === 1) {
            handleFile(files[0]);
            return;
        }
        var rootFiles = [];
        var other = [];
        var i;
        for (i = 0; i < files.length; i++) {
            var ft = detectFileType(files[i]);
            if (ft === 'root') rootFiles.push(files[i]);
            else other.push(files[i]);
        }
        if (rootFiles.length > 1 && other.length === 0) {
            handleRootFiles(rootFiles, false);
            return;
        }
        if (rootFiles.length >= 1 && other.length > 0) {
            showMessage('When selecting multiple files, use only ROOT (.root) files together, or open one file at a time.', true);
            return;
        }
        if (rootFiles.length === 1 && other.length === 0) {
            handleFile(rootFiles[0]);
            return;
        }
        handleFile(files[0]);
    }

    function onPlotClick() {
        if (leftPanelRoot && !leftPanelRoot.hidden && rootSessions.length) {
            addRootSelectedToPlot();
        } else {
            buildChart();
        }
    }

    dropZone.addEventListener('click', function (e) {
        if (e.target.id !== 'browseBtn' && !e.target.closest('#browseBtn')) fileInput.click();
    });
    if (browseBtn) browseBtn.addEventListener('click', function (e) { e.stopPropagation(); fileInput.click(); });
    fileInput.addEventListener('change', function () {
        handleFileInputList(this.files);
    });
    dropZone.addEventListener('dragover', e => { e.preventDefault(); dropZone.classList.add('dragover'); });
    dropZone.addEventListener('dragleave', () => dropZone.classList.remove('dragover'));
    dropZone.addEventListener('drop', function (e) {
        e.preventDefault();
        dropZone.classList.remove('dragover');
        handleFileInputList(e.dataTransfer.files);
    });

    if (delimiterSelect) delimiterSelect.addEventListener('change', function () {
        if (rawText) applyDelimiterAndRefresh();
    });

    if (plotBtn) plotBtn.addEventListener('click', onPlotClick);
    if (addMoreFilesBtn) addMoreFilesBtn.addEventListener('click', function (e) {
        e.preventDefault();
        appendNextFilePick = true;
        if (fileInput) fileInput.click();
    });
    if (clearPlotCanvasBtn) clearPlotCanvasBtn.addEventListener('click', function () { clearPlotCanvasOnly(); });
    if (clearAllBtn) clearAllBtn.addEventListener('click', clearAllSelectionsAndPlot);
    if (startOverBtn) startOverBtn.addEventListener('click', resetToUpload);
    var rootNormalizeEl = document.getElementById('rootNormalize');
    var rootStackEl = document.getElementById('rootStack');
    if (rootNormalizeEl) rootNormalizeEl.addEventListener('change', function () { if (currentChart) buildChart(); });
    if (rootStackEl) rootStackEl.addEventListener('change', function () { if (currentChart) buildChart(); });
    var togglePreviewBtn = document.getElementById('togglePreviewBtn');
    if (togglePreviewBtn && previewTableContainer) {
        togglePreviewBtn.addEventListener('click', function () {
            var isHidden = previewTableContainer.hidden;
            if (isHidden) {
                previewTableContainer.hidden = false;
                togglePreviewBtn.textContent = 'Hide data table';
                if (parsedData && parsedData.rows && parsedData.rows.length) {
                    renderPreview();
                }
            } else {
                previewTableContainer.hidden = true;
                togglePreviewBtn.textContent = 'Show data table';
            }
        });
    }
    if (toggleRatioBtn) {
        toggleRatioBtn.addEventListener('click', function () {
            if (!parsedData) return;
            var yc = getSelectedYIndices();
            if (yc.length < 2) return;
            ratioPanelActive = !ratioPanelActive;
            syncRatioToggleButton();
            buildChart();
        });
    }
    var panelRowsEl = document.getElementById('panelRows');
    var panelColsEl = document.getElementById('panelCols');
    if (panelRowsEl) panelRowsEl.addEventListener('change', function () {
        if (parsedData && parsedData.headers) {
            fillPanelAssignment(parsedData.headers, getSelectedYIndices());
            if (currentChart) buildChart();
        }
    });
    if (panelColsEl) panelColsEl.addEventListener('change', function () {
        if (parsedData && parsedData.headers) {
            fillPanelAssignment(parsedData.headers, getSelectedYIndices());
            if (currentChart) buildChart();
        }
    });
    if (ratioNumeratorSelect) {
        ratioNumeratorSelect.addEventListener('change', function () {
            if (!parsedData || !ratioPanelActive) return;
            buildChart();
        });
    }
    if (ratioDenominatorSelect) {
        ratioDenominatorSelect.addEventListener('change', function () {
            if (!parsedData || !ratioPanelActive) return;
            buildChart();
        });
    }
    ['ratioAxisTitle', 'ratioAxisYMin', 'ratioAxisYMax'].forEach(function (rid) {
        var rel = document.getElementById(rid);
        if (rel) {
            rel.addEventListener('change', function () {
                if (currentChart && lastPlotState.layout && lastPlotState.layout.yaxis2) applyRange();
            });
        }
    });
    var downloadConfigBtn = document.getElementById('downloadConfigBtn');
    if (downloadConfigBtn) downloadConfigBtn.addEventListener('click', function () {
        var cfg = getConfig();
        var json = JSON.stringify(cfg, null, 2);
        var blob = new Blob([json], { type: 'application/json' });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'plotter-config.json';
        a.click();
        URL.revokeObjectURL(a.href);
        showMessage('Configuration downloaded.');
    });
    var loadConfigBtn = document.getElementById('loadConfigBtn');
    var configInput = document.getElementById('configInput');
    if (loadConfigBtn && configInput) {
        loadConfigBtn.addEventListener('click', function () { configInput.click(); });
        configInput.addEventListener('change', function () {
            var f = this.files[0];
            this.value = '';
            if (!f) return;
            var reader = new FileReader();
            reader.onload = function (e) {
                try {
                    var parsed = JSON.parse(e.target.result);
                    if (applyConfig(parsed)) {
                        showMessage('Configuration loaded.' + (parsedData ? ' Chart updated.' : ' Load a data file and click Plot to apply.'));
                    } else {
                        showMessage('Not a valid plotter configuration file.', true);
                    }
                } catch (err) {
                    showMessage('Invalid JSON: ' + err.message, true);
                }
            };
            reader.onerror = function () { showMessage('Failed to read file.', true); };
            reader.readAsText(f, 'UTF-8');
        });
    }

    function switchCustomizeTab(tabId) {
        document.querySelectorAll('.custom-tab-btn').forEach(function (btn) {
            var isActive = btn.getAttribute('data-tab') === tabId;
            btn.classList.toggle('active', isActive);
            btn.setAttribute('aria-selected', isActive);
        });
        document.querySelectorAll('.custom-tab-panel').forEach(function (panel) {
            var isActive = panel.id === 'tab-' + tabId;
            panel.classList.toggle('active', isActive);
            panel.hidden = !isActive;
        });
    }

    function onRightPanelClick(e) {
        var t = e.target;
        if (!t) return;
        if (t.classList && t.classList.contains('custom-tab-btn')) {
            switchCustomizeTab(t.getAttribute('data-tab'));
            return;
        }
        var btn = t.closest && t.closest('button[id]');
        var id = (btn && btn.id) || (t.id || '');
        if (!id) return;
        if (id === 'applyRangeBtn') { applyRange(); return; }
        if (id === 'applyLabelsBtn') { applyLabels(); return; }
        if (id === 'applyGridFontBtn') { applyGridAndFont(); return; }
        if (id === 'applyCanvasSizeBtn') {
            applyCanvasSizeToContainer();
            updatePlotlyChart();
            return;
        }
        if (id === 'applyTextBtn') { applyText(); return; }
        if (id === 'exportPng') { exportImage('image/png', 'png'); return; }
        if (id === 'exportJpeg') { exportImage('image/jpeg', 'jpeg'); return; }
        if (id === 'exportPdf') { exportPdfFn(); return; }
        if (id === 'downloadPythonBtn') { downloadPythonScript(); return; }
    }
    function onRightPanelChange(e) {
        var id = e.target && e.target.id;
        if (!id) return;
        if (id === 'gridX' || id === 'gridY' || id === 'axisLabelSize' || id === 'tickSize' || id === 'axisAlign' || id === 'tickDivisions' || id === 'subTicks' || id === 'tickOffsetX' || id === 'tickOffsetY' || id === 'titleOffsetX' || id === 'titleOffsetY') { applyGridAndFont(); return; }
        if (id === 'xLogScale' || id === 'yLogScale') { applyLogScale(); return; }
        if (id === 'legendShow' || id === 'legendPosition') { applyLegend(); return; }
    }
    var panelRight = document.querySelector('.panel-right');
    if (panelRight) {
        panelRight.addEventListener('click', onRightPanelClick);
        panelRight.addEventListener('change', onRightPanelChange);
    }

    function applyPlotLineMarkerMode() {
        if (!currentChart || !lastPlotState.traces) return;
        var ct = getChartType();
        if (ct !== 'scatter' && ct !== 'line') return;
        var lineOn = plotShowLine && plotShowLine.checked;
        var markOn = plotShowMarkers && plotShowMarkers.checked;
        var w = lineWidthScatter && lineWidthScatter.value ? parseInt(lineWidthScatter.value, 10) : 2;
        if (isNaN(w) || w < 1) w = 2;
        var lwr = document.getElementById('lineWidthScatterRange');
        if (lwr) lwr.value = String(w);
        lastPlotState.traces.forEach(function (t) {
            if (t._seriesRole === 'band' || t.type !== 'scatter' || t.yaxis === 'y2') return;
            t.mode = lineOn && markOn ? 'lines+markers' : (lineOn ? 'lines' : 'markers');
            if (t.line) t.line.width = lineOn ? w : 2;
            if (t.marker) {
                if (!markOn) t.marker.size = 0;
                else if (!t.marker.size) t.marker.size = 8;
                if (markOn && !t.marker.symbol) t.marker.symbol = 'circle';
            }
        });
        fillMarkerOptions();
        updatePlotlyChart();
    }

    if (plotShowLine) plotShowLine.addEventListener('change', applyPlotLineMarkerMode);
    if (plotShowMarkers) plotShowMarkers.addEventListener('change', applyPlotLineMarkerMode);
    if (lineWidthScatter) {
        lineWidthScatter.addEventListener('change', function () {
            var lwr = document.getElementById('lineWidthScatterRange');
            if (lwr) lwr.value = this.value;
            applyPlotLineMarkerMode();
        });
    }
    var lineWidthScatterRange = document.getElementById('lineWidthScatterRange');
    if (lineWidthScatterRange && lineWidthScatter) {
        lineWidthScatterRange.addEventListener('input', function () {
            lineWidthScatter.value = this.value;
            applyPlotLineMarkerMode();
        });
    }
    if (chartTypeSelect) {
        chartTypeSelect.addEventListener('change', function () {
            var v = this.value;
            if (plotShowLine && plotShowMarkers) {
                if (v === 'scatter') { plotShowMarkers.checked = true; plotShowLine.checked = false; }
                else if (v === 'line') { plotShowLine.checked = true; plotShowMarkers.checked = false; }
            }
            if (parsedData) buildChart();
        });
    }
    if (rootTreeFilter) {
        rootTreeFilter.addEventListener('input', function () {
            renderRootTreeFiltered();
        });
    }

    function initPanelResizers() {
        var ws = document.getElementById('workspace');
        var sl = document.getElementById('splitLeft');
        var sr = document.getElementById('splitRight');
        var panelLeftEl = document.getElementById('panelLeft');
        var panelRightEl = document.querySelector('.panel-right');
        if (!ws || !sl || !sr || !panelLeftEl || !panelRightEl) return;
        var minOuter = 140;
        var minCenter = 180;
        function onMoveLeft(ev) {
            var totalW = ws.getBoundingClientRect().width;
            var pr = panelRightEl.getBoundingClientRect().width;
            var newPl = leftStart + (ev.clientX - startX);
            var maxPl = totalW - pr - 2 * 6 - minCenter;
            newPl = Math.max(minOuter, Math.min(maxPl, newPl));
            ws.style.setProperty('--panel-left-w', newPl + 'px');
        }
        function onMoveRight(ev) {
            var totalW = ws.getBoundingClientRect().width;
            var pl = panelLeftEl.getBoundingClientRect().width;
            var dx = ev.clientX - startX;
            var newPr = rightStart - dx;
            var maxPr = totalW - pl - 2 * 6 - minCenter;
            newPr = Math.max(minOuter, Math.min(maxPr, newPr));
            ws.style.setProperty('--panel-right-w', newPr + 'px');
        }
        var startX, leftStart, rightStart, drag;
        function up() {
            if (!drag) return;
            document.body.style.cursor = '';
            document.removeEventListener('mousemove', drag === 'left' ? onMoveLeft : onMoveRight);
            document.removeEventListener('mouseup', up);
            sl.classList.remove('dragging');
            sr.classList.remove('dragging');
            drag = null;
        }
        sl.addEventListener('mousedown', function (e) {
            e.preventDefault();
            drag = 'left';
            startX = e.clientX;
            leftStart = panelLeftEl.getBoundingClientRect().width;
            sl.classList.add('dragging');
            document.body.style.cursor = 'col-resize';
            document.addEventListener('mousemove', onMoveLeft);
            document.addEventListener('mouseup', up);
        });
        sr.addEventListener('mousedown', function (e) {
            e.preventDefault();
            drag = 'right';
            startX = e.clientX;
            rightStart = panelRightEl.getBoundingClientRect().width;
            sr.classList.add('dragging');
            document.body.style.cursor = 'col-resize';
            document.addEventListener('mousemove', onMoveRight);
            document.addEventListener('mouseup', up);
        });
    }

    function initNumericSliders() {
        document.querySelectorAll('.panel-right input[type="number"]').forEach(function (inp) {
            if (inp.dataset.sliderBound) return;
            var min = parseFloat(inp.min);
            var max = parseFloat(inp.max);
            if (isNaN(min) || isNaN(max)) return;
            inp.dataset.sliderBound = '1';
            var rng = document.createElement('input');
            rng.type = 'range';
            rng.className = 'num-range-slider';
            rng.min = min;
            rng.max = max;
            var span = max - min;
            var stepAttr = inp.getAttribute('step');
            var inpStep = parseFloat(inp.step);
            var rngStep;
            if (stepAttr && stepAttr !== 'any' && !isNaN(inpStep) && inpStep > 0) {
                rngStep = inpStep;
            } else {
                rngStep = span > 2000000 ? Math.max(1, Math.round(span / 2000)) : (span > 500 ? 0.1 : (span > 50 ? 1 : 0.01));
            }
            rng.step = rngStep;
            var cur = parseFloat(inp.value);
            if (isNaN(cur)) {
                if (inp.id === 'canvasWidth' || inp.id === 'canvasHeight') {
                    cur = Math.round((min + max) / 2);
                } else if (inp.id === 'tickDivisions') {
                    cur = Math.round((min + max) / 2);
                } else if (inp.id === 'xMin' || inp.id === 'xMax' || inp.id === 'yMin' || inp.id === 'yMax' ||
                    inp.id === 'ratioAxisYMin' || inp.id === 'ratioAxisYMax') {
                    cur = 0;
                } else {
                    cur = min;
                }
            }
            rng.value = String(Math.max(min, Math.min(max, cur)));
            var row = inp.closest('.field') || inp.parentNode;
            if (row) row.classList.add('field-num-wrap');
            inp.insertAdjacentElement('afterend', rng);
            function syncRngFromInput() {
                var v = parseFloat(inp.value);
                if (!isNaN(v)) rng.value = String(Math.max(min, Math.min(max, v)));
            }
            rng.addEventListener('input', function () {
                inp.value = rng.value;
                inp.dispatchEvent(new Event('input', { bubbles: true }));
                inp.dispatchEvent(new Event('change', { bubbles: true }));
            });
            inp.addEventListener('input', syncRngFromInput);
            inp.addEventListener('change', syncRngFromInput);
        });
    }

    initPanelResizers();
    initNumericSliders();
    syncRatioToggleButton();

}
